import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { flushSync } from 'react-dom';
import { DERSLER, kazanimSozleri } from '../lib/dersler.js';
import { LGS_MODU } from '../lib/ortam';
import { abSiraKaydet, abEslesmeXlsx, abSistemNoXlsx, zipUret } from './basim/abEslesme.js';
import {
  URUNLER, URUN_SIRASI, LGS_URUN_SIRASI,
  LS_DRAFT, LS_GECMIS, LS_SABLON, TASLAK_SURUM, BASLANGIC_KONU_TEST, SB_BASLANGIC, kapakTasarimlari,
} from './basim/sabitler';
import SoruBankasiPaneli, { sbKilidi, yeniTest, gecmisSbTestleri } from './basim/SoruBankasiPaneli';
import { secimYayineviCoz } from '../lib/satis';
import {
  onKontrolOzetle, bosSlotSayisi, manifestPublicNolar, manifestYalinlastir,
  zorlukQueryOlustur, konuZorlukQueryOlustur, zorlukGecerliMi, denemeZorlukKur, profilKova,
  dostHataMesaji, basimHataMesaji, basimHataDetayi, tikzBoyutTemizle, dosyaAdiUret, okulDosyaAdi,
  fisherYatesShuffle, lsRead, lsWrite, taslakEsle, konuTestDersleri, konuTestNormalize,
  konuKovaHaritasi, konuSabitListesi, sinavSuresiGecerli, SINAV_ADI_MAX, SORU_ADET_MAX, basimIsBekle,
} from './basim/yardimcilar';
import DenemePaneli from './basim/DenemePaneli';
import KonuTestiPaneli from './basim/KonuTestiPaneli';
import CiktiPaneli from './basim/CiktiPaneli';
import OnizlemePaneli from './basim/OnizlemePaneli';
import GecmisVeSablonlarPaneli from './basim/GecmisVeSablonlarPaneli';

// ============================================================================
// BASIM VE ÇIKTI — Faz C (2026-09-03, kullanıcı kararı)
//
// TEK YERLEŞİM: ÖSYM kitapçığı. Üç ürün:
//   A) TYT Denemesi (120, tam ÖSYM)   B) AYT Sayısal (80; Sözel hazırlanıyor)
//   C) Konu Testi / Genel Deneme (tek ders: ders → kazanım(lar) → adet → zorluk)
// Kaldırılanlar (ekrandan): kağıt boyutu, sütun sayısı, ÖSYM/klasik yerleşim,
// header/footer, kapak/OMR toggle'ı, kitapçık türü A/B/C/D, görsel boyutu,
// öğrenci çözüm alanı, Soru Bankası ve KDT formatları, "Yayınevi Kitapçığı" ve
// "Konu Testi 20" çipleri. Özet çubuğunda format parçası YOK.
//
// Korunan sözleşmeler: tek çıktı kaynağı sunucu PDF (pdfIndir → indir/yazdır),
// ön kontrol → önizleme → PDF aynı küme (soru_id_listesi sabitleme), sayfa
// kutulu önizleme, deneme manifestosu, ders bazlı + konu bazlı zorluk (Faz A),
// kazanım dilimleri + zorluk kotası (Faz B), `uygulanan` ekosu.
//
// İstek gövdesi TEK yerde kurulur: `ayarlarKur()` (eskiden onizlemeOlustur ve
// pdfIndir kopyalıyordu). Backend'in okuduğu sabitler burada gider:
//   sutunSayisi:2 · kitapcikTuru:'A' · cozumAlaniModu:'yok' · cozumAlaniYuksekligi:0
//
// YAYINEVİ (2026-09-15, kullanıcı kararı — yayınevleri DB listesi):
//   * `yayinevi` {id, ad} | null — Çıktı bölümündeki YayineviSecici'den ya da Satış
//     Arşivi'nden gelen ön-seçim (`baslangicYayineviId/Ad`). Seçiliyse HER isteğe
//     `ayarlar.yayineviId` gider; sunucu başka yayınevine satılmış soruyu 409
//     `satilmis_soru_baska_yayinevi` ile reddeder (önizleme/yazdır/PDF/ön kontrol
//     hepsinde) → `yayineviEngel` bandı; seçili kanalda engelli sorular listeden çıkarılır.
//   * "📕 Yayınevine verilecek" açıkken yayınevi ZORUNLU (`teslimKilidi` PDF'i kilitler);
//     yalnız PDF İNDİRME `yayineviTeslim:true` (+ `birimFiyat`) gönderir → sunucu satış
//     kaydını yazar (fiyat varsa satış, yoksa "fiyat bekliyor" teslimi). Sonuç şeridi
//     Satış Arşivi'ne götürür (`onSatisArsivineGit`). Havuz paneli ve Basım içi satış
//     modalı KALKTI; eski serbest metin yayınevi adı alanı yok.
//   * Tam denemede havuz seçeneği `ayniYayineviDahil` (yalnız yayınevi seçiliyken):
//     bu yayınevine verilmişler de havuza girer; başka yayınevinin soruları asla.
//   * Kapak "Kurum adı" seçilen yayınevi adıyla ön-dolar (boşsa ya da önceki
//     yayınevi adıysa), elle değiştirilebilir. Yayınevi taslak/şablonda SAKLANMAZ.
//
// BAĞLAM GRUBU (2026-09-15, kullanıcı kararı "bağlam temelli sorular ayrı ayrı
// satılamayacak şekilde olsun"): ortak kökü paylaşan (`kaynak_detay.baglam_grubu`)
// sorular yayınevine TEK birim olarak verilir.
//   * "📕 Yayınevine verilecek" açıkken HER isteğe (ön kontrol, önizleme, PDF, yazdır)
//     `ayarlar.grupTamamla:true` gider (`ayarlarKur`) — `yayineviTeslim`'in aksine
//     yalnız PDF indirmeye bağlı DEĞİL. Sunucu eksik kardeşleri kitapçığa ekler ve
//     `grup_eklenen:[public_no]` döndürür → `grupEklenen` şeridi (`data-grup-eklenen`).
//     Eklenen kardeşler `soru_id_listesi`'nde de vardır; sabitleme → PDF akışı aynen.
//   * Grup tamamlanamıyorsa (kardeş başka yayınevinde · basıma uygun değil · tam
//     denemede soru sayısı sabit) sunucu 409 `baglam_grubu_eksik` döner, PDF
//     üretilmez → `grupEngel` bandı (`data-grup-engel`). Seçili kanalda sorular
//     listeden, filtre kanalında havuzdan (`haricNolar`) çıkarılabilir; tam denemede
//     düğme yok (liste/manifest değiştirilir ya da teslim kapatılır).
// ============================================================================

// Bağlam grubu bandı satırı (409 `baglam_grubu_eksik`): "#A — " ardından nedenler.
// `engel` ve `uygunsuz` kardeşleri adıyla; bunların dışında kalan `eksik` kardeşler
// yalnız başka neden yoksa ya da tam denemede (soru sayısı sabit) yazılır.
const grupEngelNedeni = (g, tamDeneme) => {
  const dz = (x) => (Array.isArray(x) ? x : []);
  const parcalar = [];
  const kapsanan = new Set();
  dz(g.engel).forEach(e => {
    kapsanan.add(Number(e.public_no));
    parcalar.push(`kardeşi #${e.public_no} başka yayınevine verilmiş${e.yayinevi ? ` (${e.yayinevi})` : ''}`);
  });
  dz(g.uygunsuz).forEach(u => {
    kapsanan.add(Number(u.public_no));
    parcalar.push(`kardeşi #${u.public_no} basıma uygun değil${u.neden ? ` (${u.neden})` : ''}`);
  });
  const kalan = dz(g.eksik).map(Number).filter(n => Number.isFinite(n) && !kapsanan.has(n));
  if (kalan.length > 0 && (parcalar.length === 0 || tamDeneme)) {
    parcalar.push(`kardeşi ${kalan.map(n => `#${n}`).join(', ')} kitapçıkta yok${tamDeneme ? ' (tam denemede soru sayısı sabit)' : ''}`);
  }
  return parcalar.length > 0 ? parcalar.join('; ') : 'bağlam grubu tamamlanamadı';
};

// Baskı PDF'i onayı (kullanıcı kararı 2026-10-06: baskıya hazır çıktı HER SEFERİNDE sorulur).
const BASKI_ONAY_METNI = 'Baskıya hazır PDF (matbaa) üretilsin mi?\n\n'
  + '• Renk: CMYK — PSO Uncoated v3 (FOGRA52, kuşesiz 1. hamur), toplam mürekkep %300\n'
  + '• 3 mm taşma payı + kesim kutusu (TrimBox)\n'
  + '• PDF/X-4\n\n'
  + 'Matbaanın istediği kâğıt profili farklıysa İptal’e basın.';

// Uzman Denetimi içerik kontrolleri (backend uzmanDenetimServisi.soruKontrolleri `kontrol` adları).
const UZMAN_KONTROL_ADI = {
  anahtar_celiskisi: 'anahtar ↔ çözüm çelişkisi',
  son_cevap_harfi: 'son cevap harfi',
  panel_lint: 'LaTeX',
  toplam_sembolu: 'Σ',
  sekil_atfi: 'şekil atfı',
  sik_monoton: 'şık sırası',
  sik_esit: 'aynı ya da eksik şık',
};

// `varsayilanCozumAyri` (2026-09-14): Satış Arşivi → Basım yolunda true gelir —
// "Çözümler PDF’in sonunda" açık başlar (tek PDF: sorular + sonda çözümler) ve üstte
// bilgi şeridi görünür. Diğer girişlerde (üst çubuk, ana liste seçimi) davranış aynen.
// `authFetch` (2026-09-15): App.js AuthContext sarmalayıcısı; verilmezse yerel
// token sarmalayıcı (`satisAuthFetch`) kullanılır — YayineviSecici bunu ister.
export default function Basim({
  apiUrl, onGeri, baslangicSeciliIds = [], varsayilanCozumAyri = false,
  authFetch = null, baslangicYayineviId = null, baslangicYayineviAd = '', onSatisArsivineGit = null,
}) {
  // ---- ürün / kaynak ----
  // lgs.* (2026-10-20): yalnız LGS ürünleri; açılış Konu Testi (sözel/sayısal havuzu dolunca deneme).
  const [urun, setUrun] = useState(baslangicSeciliIds.length > 0 || LGS_MODU ? 'konu' : 'tyt');
  const [kaynakModu, setKaynakModu] = useState(baslangicSeciliIds.length > 0 ? 'secili' : 'filtre');
  const [seciliSorular, setSeciliSorular] = useState([]);
  const [seciliYukleniyor, setSeciliYukleniyor] = useState(false);
  // Müfredat TEK state: A/B'de üst düzey kısıt, C'de havuz süzgeci.
  // Varsayılan (2026-09-30, kullanıcı kararı): tam denemede MEB 2018 — iki programın soruları
  // aynı kitapçığa ancak "Karma" bilerek seçilirse girer (basım #552 seçimsiz karışık çıkmıştı).
  // Seçili sorularla açılışta (konu testi) süzgeç yok.
  // LGS'nin tamamı Maarif — müfredat süzgeci yok.
  const [mufredat, setMufredat] = useState(baslangicSeciliIds.length > 0 || LGS_MODU ? '' : 'MEB_2018');
  // Maarif seçiliyken "öğrenme çıktısı", MEB/Hepsi'de "kazanım" (2026-10-09, kullanıcı kararı).
  const soz = kazanimSozleri(mufredat);
  const urunAciklama = (u) => (soz.ad === 'kazanım' ? u.aciklama : u.aciklama.replace('kazanım(lar)', 'öğrenme çıktı(lar)ı'));
  // C: { sinav, ders, kazanimlar:[{kod,ad,adet}], adet, zorlukProfil }
  const [konuTest, setKonuTest] = useState(LGS_MODU ? { ...BASLANGIC_KONU_TEST, sinav: 'LGS' } : BASLANGIC_KONU_TEST);
  // A/B zorluk: ders bazlı kota + konu bazlı seviye
  const [dersZorluk, setDersZorluk] = useState({});
  const [konuZorluk, setKonuZorluk] = useState({});
  // Çıktı
  const [cevapAnahtariGoster, setCevapAnahtariGoster] = useState(true);
  const [cozumDosyasiAyri, setCozumDosyasiAyri] = useState(varsayilanCozumAyri);
  // Kapak kurum adı: Satış Arşivi'nden yayınevi geldiyse onunla başlar (düzenlenebilir).
  const [kurum, setKurum] = useState(baslangicYayineviAd || '');
  const [sinavTarihi, setSinavTarihi] = useState('');
  // Sınav süresi elle (2026-10-10, kullanıcı isteği): boşsa sunucu ÖSYM oranından hesaplar.
  const [sinavSuresi, setSinavSuresi] = useState('');
  // Sınav adı elle (2026-10-10): kapakta büyük başlık satırının yerine geçer; boşsa ürün kimliği.
  const [sinavAdi, setSinavAdi] = useState('');
  // Figma kapak tasarımı (2026-10-12): '' = ÖSYM kapağı; yalnız Konu Testi / Genel Deneme.
  const [kapakTasarim, setKapakTasarim] = useState('');
  // Okul kapağı {id, ad, logo_var} | null + KANIT kapak türü (2026-10-08, kullanıcı kararı).
  // Yayınevinin aksine taslak/şablonda SAKLANIR (okul her basımda aynıdır).
  const [okul, setOkul] = useState(null);
  const [kanit, setKanit] = useState({ acik: false, sinif: 9, uygulama: '' });
  // A/B KİTAPÇIK (okul denemesi, 2026-10-08): aynı sabit liste, iki sıra (lib/kitapcikSira).
  const [abKitapcik, setAbKitapcik] = useState(false);
  const [kitapcikTuru, setKitapcikTuru] = useState('A');
  // AKILLI DİZGİ (2026-10-10): sunucu sığan soruyu sütunda tutar ve soruları sayfa tasarrufu için yeniden
  // dizer (ders sırası + bağlam grupları korunur). Varsayılan AÇIK; kapatılınca istek `akilliSira:false`.
  const [akilliDizgi, setAkilliDizgi] = useState(true);
  // Sayfa hedefi (toplam PDF sayfası): boş = sunucu varsayılanı (okul sınavında 24).
  const [sayfaHedefi, setSayfaHedefi] = useState('');
  const [dizgiDurum, setDizgiDurum] = useState(null);
  // SORU BANKASI (2026-10-11): tasarım + kitap bilgisi + testler (numara listesiyle). Taslakta
  // soru gövdeleri saklanmaz (numaralar + tür seçimi); açılınca panel numaraları yeniden getirir.
  const [sb, setSb] = useState(SB_BASLANGIC);
  // Son ön kontrolün ders → soru kimlikleri haritası ("🔒 Soruları sabitle" için).
  const [dersIdleri, setDersIdleri] = useState({});

  const [onizleme, setOnizleme] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [basimSn, setBasimSn] = useState(0);   // soru bankası arka plan işinde geçen süre (basimIsBekle)
  const [yazdirKopyasi, setYazdirKopyasi] = useState(false);
  const [hata, setHata] = useState(null);
  const [hataDetay, setHataDetay] = useState(null);
  // §16 layout_ihlal reddinde "Yine de üret" için son PDF isteğinin parametreleri.
  const [layoutIhlalIstek, setLayoutIhlalIstek] = useState(null);
  // Derlenemediği için havuzdan dışlanan public_no'lar (filtre.haric).
  const [haricNolar, setHaricNolar] = useState([]);
  const [eklePaneliAcik, setEklePaneliAcik] = useState(false);
  const [onKontrol, setOnKontrol] = useState(null);
  // "Uzman Denetimi" (2026-09-30) — opsiyonel, kullanıcı tetikli, PDF üretimini bloklamaz.
  const [uzmanDenetimRaporu, setUzmanDenetimRaporu] = useState(null);
  const [uzmanDenetimYukleniyor, setUzmanDenetimYukleniyor] = useState(false);
  // Başka yayınevine satılmış soru engeli (2026-09-15): sunucu 409
  // `satilmis_soru_baska_yayinevi` → { engel:[{public_no, yayinevi, yayinevi_id, fiyatli}], hata }.
  const [yayineviEngel, setYayineviEngel] = useState(null);
  // Bağlam grubu (2026-09-15): sunucunun kitapçığa eklediği kardeşler (`grup_eklenen`,
  // public_no dizisi) ve tamamlanamayan gruplar (409 `baglam_grubu_eksik` →
  // { grup_eksik:[{public_no, baglam_grubu, eksik, engel, uygunsuz}], hata }).
  const [grupEklenen, setGrupEklenen] = useState([]);
  const [grupEngel, setGrupEngel] = useState(null);
  // Sade akış (2026-09-03): adım/preset durumu yok; önizleme alanına kaydırma referansı.
  const onizlemeRef = useRef(null);
  const [gecmisAcik, setGecmisAcik] = useState(false);
  // Tam deneme: fizibilite + manifest + slot
  const [denemeFizibilite, setDenemeFizibilite] = useState(null);
  const [oncekiDenemeHaric, setOncekiDenemeHaric] = useState(false);
  // Tam deneme uretim tarihi araligi (2026-09-21, ogretmen: "tam denemeye de ekle").
  // Konu testininki `konuTest` icinde durur (sablona yazilir); tam deneme kendi
  // durumunu tutar — urunler arasi gecis birbirinin havuzunu daraltmasin.
  const [denemeTarih, setDenemeTarih] = useState({ min: '', max: '' });
  const [denemeManifest, setDenemeManifest] = useState(null);
  const [manifestYukleniyor, setManifestYukleniyor] = useState(false);
  const [manifestNot, setManifestNot] = useState(null);
  const [aktifSlot, setAktifSlot] = useState(null);
  // Çıkarılan slotun konusu (ders:idx → konu): adetli konuda yedek AYNI konudan istenir.
  const cikarilanKonuRef = useRef({});
  // Yayınevi (DB listesi, 2026-09-15): {id, ad} | null — Satış Arşivi'nden ön-seçili gelebilir.
  const [yayineviTeslim, setYayineviTeslim] = useState(false);
  const [yayinevi, setYayinevi] = useState(() => (baslangicYayineviId != null
    ? { id: Number(baslangicYayineviId), ad: baslangicYayineviAd || '' } : null));
  const [birimFiyat, setBirimFiyat] = useState('');
  const [ayniYayineviDahil, setAyniYayineviDahil] = useState(false);
  const [yayineviSonuc, setYayineviSonuc] = useState(null);
  const [kayitYaziliyor, setKayitYaziliyor] = useState(false);   // PDF'siz satış kaydı isteği sürüyor
  // Okul denemesi kaydı (2026-10-09): okul kapaklı PDF indir/yazdır sonrası karekod kodu + adresi.
  const [denemeKayit, setDenemeKayit] = useState(null);
  // Yayınevine teslim PDF'i sonrası havuz fizibilitesi yeniden çekilir.
  const [fizibiliteSayaci, setFizibiliteSayaci] = useState(0);
  // Çözümler (2026-09-14). Kullanıcı önce "çözümleri ayrı sayfada vermesi gerekiyor ama
  // vermiyor" dedi — ayrı çözüm PDF'i derlemeden SONRA ikinci OTOMATİK indirme olarak
  // başlatılıyor, tarayıcı ("birden çok dosya" koruması) engelliyordu; ardından "aynı
  // PDF'in sonunda ayrı sayfalar olarak versin" → sunucu çözüm kitapçığını soru PDF'inin
  // SONUNA diker (`cozumSonda`), TEK dosya iner; sayfa numarası kitapçıktan devam eder.
  // Kutu sonucu söyler: { bas, son, noBas, noSon } | { hata } | null
  const [cozumDurum, setCozumDurum] = useState(null);
  // Okul sınavı: cevap anahtarı öğrenci kitapçığında YOK, ayrı öğretmen PDF'i (2026-10-10).
  // İkinci dosya otomatik inmez (tarayıcı engeller) — kutudaki düğmeyle indirilir.
  const [anahtarPdf, setAnahtarPdf] = useState(null);
  // A/B eşleme listesi: türlerin basılan sırası ({ imza, A, B }; sunucu `basilan_sira`).
  const [abSira, setAbSira] = useState(null);
  const [baskiDurum, setBaskiDurum] = useState(null);   // baskı PDF'i ön denetim sonucu (PDF/X-4)
  // Müfredat toggle sayıları (Hepsi/2018/Maarif) — /api/kazanim/ders-ozeti
  const [dersOzeti, setDersOzeti] = useState({});
  const [maarifOzeti, setMaarifOzeti] = useState({});
  const [zoomYuzde, setZoomYuzde] = useState(100);
  const [gecmis, setGecmis] = useState(() => lsRead(LS_GECMIS, []));
  const [sablonlar, setSablonlar] = useState(() => lsRead(LS_SABLON, []));
  const [draftPromptGoster, setDraftPromptGoster] = useState(false);
  const [sablonNotu, setSablonNotu] = useState(null);

  // ---- türetilen ----
  const urunBilgi = URUNLER[urun] || URUNLER.tyt;
  // Tam deneme = sınav türü taşıyan her ürün (TYT / AYT / AYT_SOZEL) — slot-ders 2026-09-03.
  const tamDenemeAktif = urun !== 'konu' && !!urunBilgi.sinav;
  const sbAktif = urun === 'soru_bankasi';
  const sbTaslak = () => ({ ...sb, testler: sb.testler.map(({ ad, metin, tur }) => ({ ad, metin, tur })) });
  const sinavTuru = urunBilgi.sinav;
  const seciliCount = seciliSorular.length;
  // ÇOK DERSLİ KONU TESTİ (2026-09-03): ders listesi + ders başına hedef adet.
  const konuDersler = useMemo(() => konuTestDersleri(konuTest), [konuTest]);
  const dersHedefAdet = (d) => (Array.isArray(d.sabitIds) && d.sabitIds.length > 0
    ? d.sabitIds.length
    : (d.kazanimlar.length > 0
      ? d.kazanimlar.reduce((a, k) => a + (Number(k.adet) || 0), 0)
      : (Number(d.adet) || 0)));
  const konuHedefAdet = konuDersler.reduce((a, d) => a + dersHedefAdet(d), 0);
  const cokDersli = konuDersler.length > 1;
  const dersEtiketi = (d) => (d ? (DERSLER.find(x => x.value === d)?.label || d) : 'ders seçilmedi');
  // Seçili kanalda tüm sorular tek dersteyse başlık bandı için ders (karma → yok).
  const seciliTekDers = (liste) => {
    const set = new Set((liste || []).map(s => String(s.ders || '')).filter(Boolean));
    return set.size === 1 ? [...set][0] : '';
  };
  // Birim fiyat (isteğe bağlı): '' → null (fiyat bekleyen teslim); sayı ≥ 0 → satış.
  const birimFiyatSayi = String(birimFiyat).trim() === '' ? null : Number(String(birimFiyat).trim().replace(',', '.'));
  const birimFiyatGecerli = birimFiyatSayi === null || (Number.isFinite(birimFiyatSayi) && birimFiyatSayi >= 0);
  // Teslim kilidi: "Yayınevine verilecek" açıkken yayınevi seçilmeli, fiyat geçerli olmalı → PDF kapalı.
  const teslimKilidi = !yayineviTeslim ? '' : (!yayinevi || yayinevi.id == null)
    ? 'yayınevi seçilmedi' : (!birimFiyatGecerli ? 'birim fiyat geçersiz' : '');
  const yayineviId = yayinevi && yayinevi.id != null ? yayinevi.id : null;

  // ============================================================
  // EFEKTLER
  // ============================================================

  // Yazdırma kopyası yalnız tarayıcı yazdırırken DOM'a girer (2026-09-30). Sürekli dururken
  // önizleme SVG'si sayfada İKİ kez ve aynı kimliklerle bulunuyordu: 37 sayfalık kitapçıkta
  // 74 bin <use> yeniden çözülüyor, sekme ~23 sn donuyordu (tek kopya 1-5 sn).
  useEffect(() => {
    const ac = () => flushSync(() => setYazdirKopyasi(true));
    const kapat = () => setYazdirKopyasi(false);
    window.addEventListener('beforeprint', ac);
    window.addEventListener('afterprint', kapat);
    return () => {
      window.removeEventListener('beforeprint', ac);
      window.removeEventListener('afterprint', kapat);
    };
  }, []);

  // Kapsam değişince dışlama listesi sıfırlanır (bir basım oturumuna aittir).
  useEffect(() => {
    setHaricNolar([]);
  }, [urun, konuTest.dersler, konuTest.ders, konuTest.kazanimlar, konuTest.sinif, konuTest.hafta, mufredat, kaynakModu]);

  // "Yayınevine verilecek" kapanınca bağlam grubu şeridi ve bandı düşer (artık
  // `grupTamamla` gitmez; eski kitapçığın kardeş bilgisi yanıltmasın).
  useEffect(() => {
    if (!yayineviTeslim) { setGrupEklenen([]); setGrupEngel(null); }
  }, [yayineviTeslim]);

  // baslangicSeciliIds geldiğinde tam soru objelerini DB'den çek
  useEffect(() => {
    if (baslangicSeciliIds.length === 0) return;
    const token = localStorage.getItem('yks_token');
    setSeciliYukleniyor(true);
    fetch(`${apiUrl}/api/sorular/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
      body: JSON.stringify({ ids: baslangicSeciliIds }),
    })
      .then(r => r.json())
      .then(data => {
        if (data.sorular) setSeciliSorular(data.sorular);
        else setHata(data.hata || 'Sorular alınamadı');
      })
      .catch(e => setHata(e.message))
      .finally(() => setSeciliYukleniyor(false));
  }, [baslangicSeciliIds, apiUrl]);

  // Tam deneme fizibilitesi — GET /basim/deneme-fizibilite (ders + konu bazlı zorluk dahil)
  useEffect(() => {
    if (!tamDenemeAktif || !sinavTuru) { setDenemeFizibilite(null); return; }
    const token = localStorage.getItem('yks_token');
    const p = new URLSearchParams({ sinavTuru });
    if (mufredat) p.set('mufredat', mufredat);
    if (oncekiDenemeHaric) p.set('oncekiDenemeHaric', '1');
    // Yayınevi seçiliyse havuz o yayınevine göre süzülür; "bu yayınevine verilenler de
    // dahil" yalnız yayınevi varken anlamlı (backend başkasına satılmışı hep dışlar).
    if (yayineviId != null) {
      p.set('yayineviId', String(yayineviId));
      if (ayniYayineviDahil) p.set('ayniYayineviDahil', '1');
    }
    const zq = zorlukQueryOlustur(dersZorluk);
    if (zq) p.set('denemeZorluk', zq);
    // Konu adları boşluk/Türkçe içerdiği için ayrı param, URL-kodlu JSON (Faz A).
    const kq = konuZorlukQueryOlustur(konuZorluk);
    if (kq) p.set('denemeZorlukKonu', kq);
    // Tarih araligi fizibiliteye de gider: "havuz yeterli" hukmu SECIMLE ayni
    // havuzdan verilmeli (aksi halde yesil gorunup secim eksik doner).
    if (denemeTarih.min) p.set('tarih_min', denemeTarih.min);
    if (denemeTarih.max) p.set('tarih_max', denemeTarih.max);
    fetch(`${apiUrl}/api/boru-hatti/basim/deneme-fizibilite?${p}`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
      .then(r => r.json())
      .then(d => setDenemeFizibilite(d && d.basarili ? d : null))
      .catch(() => setDenemeFizibilite(null));
  }, [tamDenemeAktif, sinavTuru, mufredat, oncekiDenemeHaric, yayineviId, ayniYayineviDahil, dersZorluk, konuZorluk, denemeTarih, apiUrl, fizibiliteSayaci]);

  // Ders özeti — müfredat toggle sayıları (onaylı), bir kez yüklenir.
  useEffect(() => {
    const token = localStorage.getItem('yks_token');
    fetch(`${apiUrl}/api/kazanim/ders-ozeti?durum=onaylandi`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
      .then(r => r.json())
      .then(d => { setDersOzeti(d.sayilar || {}); setMaarifOzeti(d.maarif || {}); })
      .catch(() => {});
  }, [apiUrl]);

  // Auto-save draft (v2 şema) — değişikliklerden 1.5s sonra. Yayınevi kimliği
  // taslağa YAZILMAZ (oturuma özgü seçim); `ayniYayineviDahil` yazılır.
  useEffect(() => {
    const draft = {
      surum: TASLAK_SURUM,
      urun, kaynakModu, mufredat, konuTest, dersZorluk, konuZorluk,
      cevapAnahtariGoster, cozumDosyasiAyri, kurum, sinavTarihi, sinavSuresi, sinavAdi, kapakTasarim, okul, kanit, abKitapcik, akilliDizgi, sayfaHedefi, ayniYayineviDahil,
      denemeManifest, sb: sbTaslak(),
      seciliIds: seciliSorular.map(s => s.id),
      tarih: Date.now(),
    };
    const t = setTimeout(() => lsWrite(LS_DRAFT, draft), 1500);
    return () => clearTimeout(t);
  }, [urun, kaynakModu, mufredat, konuTest, dersZorluk, konuZorluk, cevapAnahtariGoster,
      cozumDosyasiAyri, kurum, sinavTarihi, sinavSuresi, sinavAdi, kapakTasarim, okul, kanit, abKitapcik, akilliDizgi, sayfaHedefi, ayniYayineviDahil, denemeManifest, seciliSorular, sb]);

  // Draft restore prompt mount sırasında
  useEffect(() => {
    if (baslangicSeciliIds.length > 0) return; // App.js'den geldiyse atla
    const draft = lsRead(LS_DRAFT);
    if (draft && (Date.now() - (draft.tarih || 0)) < 24 * 60 * 60 * 1000) {
      setDraftPromptGoster(true);
    }
  }, []);

  // Klavye kısayolları (D3)
  useEffect(() => {
    const handler = (e) => {
      const ctrl = e.ctrlKey || e.metaKey;
      const inputAktif = ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName);
      if (ctrl && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        if (onizleme) pdfIndir({ sabitIds: onizleme.soru_id_listesi, cikti: 'yazdir' });
      } else if (ctrl && e.key.toLowerCase() === 's') {
        e.preventDefault();
        if (onizleme) pdfIndir({ sabitIds: onizleme.soru_id_listesi });
      } else if (ctrl && e.key === 'Enter') {
        e.preventDefault();
        onizlemeOlustur();
      } else if (e.key === 'Escape' && !inputAktif && onGeri) {
        e.preventDefault();
        onGeri();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onizleme, teslimKilidi]);

  // Manifest bir yapılandırmaya aittir; yapılandırma değişince BAYATLAR.
  const manifestBayatlat = useCallback((neden) => {
    setDenemeManifest(prev => {
      if (!prev) return prev;
      setManifestNot(`${neden} — deneme listesi sıfırlandı, yeniden oluşturun.`);
      setAktifSlot(null);
      return null;
    });
  }, []);
  const ilkYapilandirma = useRef(true);
  useEffect(() => {
    if (ilkYapilandirma.current) { ilkYapilandirma.current = false; return; }
    manifestBayatlat('Müfredat / zorluk dağılımı / konu seviyesi / havuz kapsamı değişti');
  }, [mufredat, ayniYayineviDahil, yayineviId, oncekiDenemeHaric, dersZorluk, konuZorluk, denemeTarih, manifestBayatlat]);

  // ============================================================
  // TASLAK / ŞABLON (v2 şema; eskiler taslakEsle ile çevrilir)
  // ============================================================
  const durumUygula = (t) => {
    if (!t) return;
    setUrun(URUNLER[t.urun] && !URUNLER[t.urun].pasif ? t.urun : 'konu');
    setKaynakModu(t.kaynakModu === 'secili' ? 'secili' : 'filtre');
    setMufredat(t.mufredat || '');
    setKonuTest(konuTestNormalize({ ...BASLANGIC_KONU_TEST, ...(t.konuTest || {}) }));
    setDersZorluk(t.dersZorluk || {});
    setKonuZorluk(t.konuZorluk || {});
    setCevapAnahtariGoster(t.cevapAnahtariGoster !== false);
    setCozumDosyasiAyri(t.cozumDosyasiAyri === true);
    setKurum(t.kurum || '');
    setSinavTarihi(t.sinavTarihi || '');
    setSinavSuresi(t.sinavSuresi != null ? String(t.sinavSuresi) : '');
    setSinavAdi(typeof t.sinavAdi === 'string' ? t.sinavAdi : '');
    setKapakTasarim(kapakTasarimlari(LGS_MODU).some(k => k.id === t.kapakTasarim) ? t.kapakTasarim : '');
    setOkul(t.okul && t.okul.id != null ? t.okul : null);
    setKanit(t.kanit && typeof t.kanit === 'object'
      ? { acik: t.kanit.acik === true, sinif: [9, 10, 11].includes(Number(t.kanit.sinif)) ? Number(t.kanit.sinif) : 9, uygulama: t.kanit.uygulama || '' }
      : { acik: false, sinif: 9, uygulama: '' });
    setAbKitapcik(t.abKitapcik === true);
    setAkilliDizgi(t.akilliDizgi !== false);
    setSayfaHedefi(t.sayfaHedefi ? String(t.sayfaHedefi) : '');
    setKitapcikTuru('A');
    setAyniYayineviDahil(t.ayniYayineviDahil === true);
    setOncekiDenemeHaric(t.oncekiDenemeHaric === true);
    if (t.denemeManifest) setDenemeManifest(t.denemeManifest);
    if (t.sb && Array.isArray(t.sb.testler) && t.sb.testler.length > 0) {
      setSb({ ...SB_BASLANGIC, ...t.sb, testler: t.sb.testler.map(x => ({ ...yeniTest(), ...x, sorular: [] })) });
    }
    if (Array.isArray(t.seciliIds) && t.seciliIds.length > 0) {
      const token = localStorage.getItem('yks_token');
      fetch(`${apiUrl}/api/sorular/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
        body: JSON.stringify({ ids: t.seciliIds }),
      })
        .then(r => r.json())
        .then(d => { if (d.sorular) setSeciliSorular(d.sorular); })
        .catch(() => {});
    }
    setSablonNotu(t.eskiSablon
      ? `Eski biçim yeni düzene çevrildi${t.eskiKonuSecimi ? ` — eski konu seçimi taşınmadı, ${kazanimSozleri(t.mufredat).ad} seçin` : ''}.`
      : null);
    setOnizleme(null); setOnKontrol(null); setHata(null); setHataDetay(null); setYayineviEngel(null);
    setGrupEngel(null); setGrupEklenen([]);
  };
  const draftYukle = () => {
    durumUygula(taslakEsle(lsRead(LS_DRAFT)));
    setDraftPromptGoster(false);
  };
  const draftReddet = () => {
    localStorage.removeItem(LS_DRAFT);
    setDraftPromptGoster(false);
  };
  const gecmiseKaydet = (kayit) => {
    const yeni = [kayit, ...gecmis].slice(0, 10);
    setGecmis(yeni);
    lsWrite(LS_GECMIS, yeni);
  };
  // Şablon (tarayıcı) ve sunucu taslağı AYNI durum nesnesini saklar; geri yükleme `durumUygula`.
  const durumNesnesi = () => ({
    tarih: Date.now(), surum: TASLAK_SURUM,
    urun, kaynakModu, mufredat, konuTest, dersZorluk, konuZorluk,
    cevapAnahtariGoster, cozumDosyasiAyri, kurum, sinavTarihi, sinavSuresi, sinavAdi, kapakTasarim, okul, kanit, abKitapcik, akilliDizgi, sayfaHedefi, oncekiDenemeHaric, ayniYayineviDahil,
    sb: sbTaslak(),
  });
  const varsayilanAd = () => (urun === 'konu' && konuTest.ders ? (cokDersli ? `Genel Deneme · ${konuDersler.length} ders` : `${urunBilgi.kisa} · ${dersEtiketi(konuTest.ders)}`) : urunBilgi.ad);
  const sablonKaydet = () => {
    const ad = window.prompt('Şablon adı:', varsayilanAd() || `Şablon ${sablonlar.length + 1}`);
    if (!ad) return;
    const yeni = [...sablonlar, { ad, ...durumNesnesi() }];
    setSablonlar(yeni);
    lsWrite(LS_SABLON, yeni);
  };
  const sablonYukle = (sablon) => {
    durumUygula(taslakEsle(sablon));
    setAktifTaslak(null);    // tarayıcı şablonu sunucu taslağı değil
    setGecmisAcik(false);   // yüklenen seçimler hemen görünsün (sade akış 2026-09-03)
  };

  // SUNUCU TASLAĞI (Faz 3, 2026-10-09): adıyla kaydedilir, her cihazdan açılır (/api/basim-taslak).
  // Açık taslak `aktifTaslak` ({id, ad, surum}); "Kaydet" iyimser kilitle günceller (409 → uyarı).
  const [aktifTaslak, setAktifTaslak] = useState(null);
  const [taslakNot, setTaslakNot] = useState(null);   // { tip: 'bilgi'|'hata', metin }
  const taslakIstek = async (yol, secenek = {}) => {
    const token = localStorage.getItem('yks_token');
    const r = await fetch(`${apiUrl}/api/basim-taslak${yol}`, {
      ...secenek,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    });
    const j = await r.json().catch(() => ({}));
    return { durumKodu: r.status, j };
  };
  const taslakKaydet = async (farkli = false) => {
    setTaslakNot(null);
    try {
      if (aktifTaslak && !farkli) {
        const { durumKodu, j } = await taslakIstek(`/${aktifTaslak.id}`, {
          method: 'PUT', body: JSON.stringify({ durum: durumNesnesi(), surum: aktifTaslak.surum }) });
        if (durumKodu === 409) { setTaslakNot({ tip: 'hata', metin: j.hata || 'Taslak bu arada değişti.' }); return; }
        if (!j.basarili) throw new Error(j.hata || `HTTP ${durumKodu}`);
        setAktifTaslak({ id: j.taslak.id, ad: j.taslak.ad, surum: j.taslak.surum });
        setTaslakNot({ tip: 'bilgi', metin: `“${j.taslak.ad}” kaydedildi (sürüm ${j.taslak.surum}).` });
        return;
      }
      const ad = window.prompt('Taslak adı:', farkli && aktifTaslak ? `${aktifTaslak.ad} (kopya)` : varsayilanAd());
      if (!ad) return;
      const { durumKodu, j } = await taslakIstek('', { method: 'POST', body: JSON.stringify({ ad, durum: durumNesnesi() }) });
      if (!j.basarili) throw new Error(j.hata || `HTTP ${durumKodu}`);
      setAktifTaslak({ id: j.taslak.id, ad: j.taslak.ad, surum: j.taslak.surum });
      setTaslakNot({ tip: 'bilgi', metin: `“${j.taslak.ad}” sunucuya kaydedildi.` });
    } catch (e) {
      setTaslakNot({ tip: 'hata', metin: `Taslak kaydedilemedi: ${e.message}` });
    }
  };
  const taslakYukle = async (id) => {
    setTaslakNot(null);
    try {
      const { durumKodu, j } = await taslakIstek(`/${id}`);
      if (!j.basarili) throw new Error(j.hata || `HTTP ${durumKodu}`);
      durumUygula(taslakEsle(j.taslak.durum));
      setAktifTaslak({ id: j.taslak.id, ad: j.taslak.ad, surum: j.taslak.surum });
      setGecmisAcik(false);
    } catch (e) {
      setTaslakNot({ tip: 'hata', metin: `Taslak açılamadı: ${e.message}` });
    }
  };
  const sablonSil = (idx) => {
    const yeni = sablonlar.filter((_, i) => i !== idx);
    setSablonlar(yeni);
    lsWrite(LS_SABLON, yeni);
  };

  // ============================================================
  // ÜRÜN SEÇİMİ / HAZIR ÇİPLER
  // ============================================================
  // Ürün değişince ürüne özgü geçici durum temizlenir (manifest, zorluk, önizleme).
  // GEÇMİŞTEN YENİDEN BASIM (2026-10-20, kullanıcı isteği "geçmiş baskıları doğrudan seçerek soru bankası ya
  // da deneme şablonunda yeniden basabilmeliyim"): sunucu basım kaydının numaraları AYNI SIRAYLA yüklenir.
  // Deneme → numara listesi (dersler + ÖSYM testleri kendiliğinden); soru bankası → kaydın test bölümü.
  // Sorular tek alıcıya satılmışsa o alıcı seçilir: yeniden basımdır, yeni satış kaydı yazılmaz.
  const [numaraDolgu, setNumaraDolgu] = useState(null);   // { metin, alici } → NumaraListesi
  const yenidenBas = async (k, hedef) => {
    const nolar = (k.public_no_listesi || []).map(Number).filter(Number.isFinite);
    if (nolar.length === 0) return;
    const token = localStorage.getItem('yks_token');
    const sorular = [];
    try {
      for (let i = 0; i < nolar.length; i += 500) {   // sunucu tek istekte en çok 500 numara
        const r = await fetch(`${apiUrl}/api/sorular/batch`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
          body: JSON.stringify({ public_nolar: nolar.slice(i, i + 500) }),
        });
        const d = await r.json().catch(() => ({}));
        if (Array.isArray(d.sorular)) sorular.push(...d.sorular);
      }
    } catch (_) { /* alıcı seçilemez; numara listesi / test kartı basılamayanı nedeniyle gösterir */ }
    const c = secimYayineviCoz(sorular);
    const alici = !c.karisik && c.yayineviId != null ? { id: c.yayineviId, ad: c.yayineviAd } : null;
    if (alici) yayineviSec(alici);
    if (hedef === 'soru_bankasi') {
      urunSec('soru_bankasi');
      setSb(p => ({ ...p, testler: gecmisSbTestleri(k).map(t => ({ ...yeniTest(), ad: t.ad, metin: t.nolar.join(', '), tur: t.tur })) }));
    } else {
      urunSec('konu');
      setKaynakModu('filtre');
      setNumaraDolgu({ metin: nolar.join(', '), alici: alici ? alici.id : yayineviId });
    }
    const tarih = new Date(k.olusturulma_zamani).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    setSablonNotu(`Basım kaydı #${k.id} (${tarih}) — ${nolar.length} soru ${hedef === 'soru_bankasi' ? 'soru bankası testlerine' : 'numara listesine'} aynı sırayla yüklendi`
      + (alici ? `; sorular ${alici.ad} alıcısında, yeniden basım olarak açıldı (yeni satış kaydı yazılmaz).` : '.'));
    setOnizleme(null); setOnKontrol(null); setHata(null); setHataDetay(null);
    setGecmisAcik(false);
  };

  // SEÇİLİ SORULAR → SORU BANKASI (2026-10-20, kullanıcı bulgusu: Satış Arşivi'nden getirilen "soru bankası olarak
  // satılmış" sorular Konu Testi'ne düşüyor, Soru Bankası seçilince oraya geçmiyordu). Bu soruları içeren en yeni
  // soru bankası basımı varsa onun test bölümü (ad + tür + sıra) kullanılır, yoksa sırayla bölünür.
  const sbSeciliden = async (sorular) => {
    const nolar = sorular.map(s => Number(s.public_no)).filter(Number.isFinite);
    const secim = new Set(nolar);
    let kayit = null;
    try {
      const token = localStorage.getItem('yks_token');
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/kayitlar?tip=soru-bankasi&sonuc=basarili&limit=50`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const d = await r.json();
      kayit = (d.kayitlar || []).find(k => Array.isArray(k.sb_testler)
        && nolar.every(n => (k.public_no_listesi || []).includes(n))) || null;
    } catch (_) { /* kayıt okunamazsa sırayla bölünür */ }
    const testler = kayit
      ? kayit.sb_testler.map(t => ({ ...t, nolar: t.nolar.filter(n => secim.has(n)) })).filter(t => t.nolar.length > 0)
      : gecmisSbTestleri({ public_no_listesi: nolar });
    setSb(p => ({ ...p, testler: testler.map(t => ({ ...yeniTest(), ad: t.ad || '', metin: t.nolar.join(', '), tur: t.tur || {} })) }));
    setSablonNotu(kayit
      ? `${nolar.length} seçili soru Soru Bankası'na aktarıldı — basım kaydı #${kayit.id}'in test bölümüyle (${testler.length} test).`
      : `${nolar.length} seçili soru Soru Bankası'na aktarıldı — ${testler.length} teste bölündü; test adlarını yazabilirsiniz.`);
  };

  const urunSec = (u) => {
    if (!URUNLER[u] || URUNLER[u].pasif) return;
    if (u === 'soru_bankasi' && u !== urun && seciliCount > 0
      && !sb.testler.some(t => String(t.metin || '').trim())) sbSeciliden(seciliSorular);
    if (u !== urun) {
      setDenemeManifest(null); setAktifSlot(null); setManifestNot(null);
      setDersZorluk({}); setKonuZorluk({});
      setOnizleme(null); setOnKontrol(null); setHata(null); setHataDetay(null); setLayoutIhlalIstek(null);
      setYayineviEngel(null); setGrupEngel(null); setGrupEklenen([]);
    }
    setUrun(u);
    // Soru bankası çözümleri kitabın parçasıdır (taslaktaki gibi): seçilince "çözümler sonda" açılır.
    if (u === 'soru_bankasi' && u !== urun) setCozumDosyasiAyri(true);
    // Denemeler yalnız filtre kanalında; konu testinde elle seçilmiş soru varsa seçili kalır.
    if (u !== 'konu') setKaynakModu('filtre');
    else if (seciliCount > 0) setKaynakModu('secili');
  };

  // ============================================================
  // SEÇİLİ SORULAR (C — elle seçim)
  // ============================================================
  const soruyuSil = useCallback((id) => {
    setSeciliSorular(prev => prev.filter(s => s.id !== id));
  }, []);
  const soruyuTasi = useCallback((index, yon) => {
    setSeciliSorular(prev => {
      const yeni = [...prev];
      const hedef = index + yon;
      if (hedef < 0 || hedef >= yeni.length) return prev;
      [yeni[index], yeni[hedef]] = [yeni[hedef], yeni[index]];
      return yeni;
    });
  }, []);
  const soruEkle = useCallback((soru) => {
    setSeciliSorular(prev => prev.find(s => s.id === soru.id) ? prev : [...prev, soru]);
  }, []);
  const sorulariEkle = useCallback((soruArr) => {
    setSeciliSorular(prev => {
      const mevcut = new Set(prev.map(s => s.id));
      return [...prev, ...soruArr.filter(s => !mevcut.has(s.id))];
    });
  }, []);
  const seciliKaristir = () => setSeciliSorular(prev => fisherYatesShuffle(prev));
  const seciliTemizle = () => setSeciliSorular([]);

  // Drag-drop (B8)
  const dragIndexRef = useRef(null);
  const dragHandlers = (index) => ({
    draggable: true,
    onDragStart: (e) => {
      dragIndexRef.current = index;
      e.dataTransfer.effectAllowed = 'move';
      e.target.classList.add('dragging');
    },
    onDragEnd: (e) => {
      e.target.classList.remove('dragging');
      document.querySelectorAll('.drop-target-before').forEach(el => el.classList.remove('drop-target-before'));
    },
    onDragOver: (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      e.currentTarget.classList.add('drop-target-before');
    },
    onDragLeave: (e) => {
      e.currentTarget.classList.remove('drop-target-before');
    },
    onDrop: (e) => {
      e.preventDefault();
      e.currentTarget.classList.remove('drop-target-before');
      const from = dragIndexRef.current;
      const to = index;
      if (from === null || from === to) return;
      setSeciliSorular(prev => {
        const yeni = [...prev];
        const [item] = yeni.splice(from, 1);
        yeni.splice(to, 0, item);
        return yeni;
      });
      dragIndexRef.current = null;
    },
  });

  // ============================================================
  // İSTEK GÖVDESİ — TEK KAYNAK
  // ============================================================
  const konuFiltresiOlustur = (haric) => {
    const adet = konuHedefAdet;
    const f = { mufredat: mufredat || undefined, adet, haric };
    if (cokDersli) {
      // ÇOK DERSLİ GENEL DENEME: ders planı (ders başına adet + kazanımlar); backend
      // ÖSYM çok-testli kitapçık üretir (kapak + test başlıkları + test bölümlü anahtar).
      f.dersPlani = konuDersler.map(d => ({
        ders: d.ders,
        adet: dersHedefAdet(d),
        // Sabitlenmiş ders (okul denemesi: SAY ↔ EA ortak Mat/Geo aynı sorular).
        ...(Array.isArray(d.sabitIds) && d.sabitIds.length > 0 ? { soruIds: d.sabitIds }
          : (d.kazanimlar.length > 0 ? { kazanimDagilimi: d.kazanimlar.map(k => ({ kazanim_kodu: k.kod, adet: k.adet })) } : {})),
      }));
    } else {
      const d = konuDersler[0];
      f.ders = d ? d.ders : undefined;
      // Kazanım(lar): tek kazanımda da kazanimDagilimi (zorlukKota ile birlikte
      // çalışan kanal budur; eski kazanim_kodu prefix yolu kota uygulamaz).
      if (d && d.kazanimlar.length > 0) f.kazanimDagilimi = d.kazanimlar.map(k => ({ kazanim_kodu: k.kod, adet: k.adet }));
    }
    const kota = profilKova(konuTest.zorlukProfil, adet);
    if (kota) f.zorlukKota = kota;
    // Uretim tarihi araligi (2026-09-21, ogretmen istegi: filtre kanalina da).
    // Havuzu daraltir; bos birakilirsa eski davranis (tum havuz).
    if (konuTest.tarihMin) f.tarih_min = konuTest.tarihMin;
    if (konuTest.tarihMax) f.tarih_max = konuTest.tarihMax;
    // OKUL DENEMESİ süzgeçleri (2026-10-08): sınıf, zorluk puan aralığı, bağlam çifti
    // dışlama, cevap harfi payı (her harf ≤ %30).
    if ([9, 10, 11, 12].includes(Number(konuTest.sinif))) f.sinif = Number(konuTest.sinif);
    if (konuTest.puanMin !== '' && konuTest.puanMin != null) f.puanMin = Number(konuTest.puanMin);
    if (konuTest.puanMax !== '' && konuTest.puanMax != null) f.puanMax = Number(konuTest.puanMax);
    if (konuTest.baglamHaric) f.baglamHaric = true;
    if (konuTest.harfDengesi) f.harfDengesi = true;
    // HAFTA SÜZGECİ (TYMM Öğrenme Kanıtı, 2026-10-09): yıllık planda o haftaya kadar tamamlanan ÖÇ'ler.
    // Yıllık plan 9-11. sınıf için var; 12. sınıfta hafta gönderilmez.
    if ([9, 10, 11].includes(f.sinif) && Number(konuTest.hafta) >= 1) {
      f.hafta = Number(konuTest.hafta);
      if (Number(konuTest.cografyaSaat) === 4) f.cografyaSaat = 4;
    }
    return f;
  };

  // SORU BANKASI gövdesi (sunucu: pipeline _sbDogrula). Kitap kimliği panelden; okul kapağı,
  // A/B, Öğrenme Kanıtı ve kapak seti bu üründe yok. soruIds = testlerin sıralı birleşimi.
  const sbGovde = ({ formatTipi, cikti }) => {
    const dolu = sb.testler.filter(t => t.sorular.length > 0);
    const sbTestler = dolu.map((t, i) => ({
      ad: t.ad.trim() || `Test ${i + 1}`,
      soruIds: t.sorular.map(s => s.id),
      ...(Object.keys(t.tur || {}).length ? { tur: t.tur } : {}),
    }));
    const kitap = { ders: sb.ders.trim() || 'Matematik', baslik: sb.baslik.trim() || 'Soru Bankası' };
    if (sb.altBaslik.trim()) kitap.altBaslik = sb.altBaslik.trim();
    if (sb.yil.trim()) kitap.yil = sb.yil.trim();
    if ([9, 10, 11, 12].includes(Number(sb.sinif))) kitap.sinif = Number(sb.sinif);
    if (sb.logoSvg) kitap.logoSvg = sb.logoSvg;
    const ayarlar = { formatTipi, cevapAnahtariGoster, cozumSonda: cozumDosyasiAyri, sbTasarim: sb.tasarim, sbKitap: kitap, sbTestler };
    if (yayineviId != null) ayarlar.yayineviId = yayineviId;
    if (yayineviTeslim && cikti === 'indir' && formatTipi === 'pdf') {
      ayarlar.yayineviTeslim = true;
      if (birimFiyatSayi !== null && birimFiyatGecerli) ayarlar.birimFiyat = birimFiyatSayi;
    }
    if (!akilliDizgi) ayarlar.akilliSira = false;
    else if (/^\d+$/.test(String(sayfaHedefi).trim()) && Number(sayfaHedefi) >= 4) ayarlar.sayfaHedefi = Number(sayfaHedefi);
    return { body: { soruIds: sbTestler.flatMap(t => t.soruIds), ayarlar }, tamDeneme: false };
  };

  const ayarlarKur = ({ formatTipi = 'svg', sabitIds = null, overrideHaric = null, manifestiAtla = false,
    layoutZorla = false, cikti = 'indir', kaynakSorular = null, tur = null, ab = null } = {}) => {
    if (sbAktif) return sbGovde({ formatTipi, cikti });
    const abAcik = !tamDenemeAktif && (ab == null ? abKitapcik : ab);
    const tamDeneme = tamDenemeAktif;
    const haric = (Array.isArray(overrideHaric) && overrideHaric.length > 0)
      ? overrideHaric : (haricNolar.length > 0 ? haricNolar : undefined);
    const ayarlar = {
      formatTipi,
      cevapAnahtariGoster,
      // Çözümler aynı PDF'in sonunda (2026-09-14, kullanıcı). Durum adı eski
      // (`cozumDosyasiAyri`) — şablon anahtarı olduğu için korunur; sunucuya `cozumSonda`.
      cozumSonda: cozumDosyasiAyri,
      // ÖSYM tek yerleşim sabitleri (backend canlı alanlar)
      sutunSayisi: 2,
      kitapcikTuru: abAcik ? (tur || kitapcikTuru) : 'A',
      cozumAlaniModu: 'yok',
      cozumAlaniYuksekligi: 0,
    };
    if (layoutZorla) ayarlar.layoutDogrulamaSiki = false;
    // YAYINEVİ — seçiliyse HER isteğe gider (başka yayınevine satılmış soru kuralı
    // önizleme/yazdır/PDF/ön kontrol hepsinde); teslim + birim fiyat yalnız PDF İNDİRME
    // isteğinde (kaydı yazan tek istek; önizleme/yazdırma kayıt yazmaz).
    if (yayineviId != null) ayarlar.yayineviId = yayineviId;
    // BAĞLAM GRUBU (2026-09-15): teslim açıkken HER istek (ön kontrol / önizleme / PDF /
    // yazdır) `grupTamamla` taşır — sunucu eksik kardeşleri ekler ya da 409
    // `baglam_grubu_eksik` döner. `yayineviTeslim`'in aksine çıktı türüne bağlı DEĞİL.
    if (yayineviTeslim) ayarlar.grupTamamla = true;
    if (yayineviTeslim && cikti === 'indir' && formatTipi === 'pdf') {
      ayarlar.yayineviTeslim = true;
      if (birimFiyatSayi !== null && birimFiyatGecerli) ayarlar.birimFiyat = birimFiyatSayi;
    }
    // ÖSYM kapak seti (kapak + açıklama + arka kapak) HER üründe formatın parçası.
    ayarlar.kapakSayfasi = true;
    if (kurum.trim()) ayarlar.kurum = kurum.trim();
    if (sinavTarihi) ayarlar.sinavTarihi = sinavTarihi;
    if (sinavSuresiGecerli(sinavSuresi)) ayarlar.sinavSuresi = Number(sinavSuresi);
    if (sinavAdi.trim()) ayarlar.sinavAdi = sinavAdi.trim().slice(0, SINAV_ADI_MAX);
    // Okul kapağı: sunucu okul adını kurumun yerine koyar, logoyu kapağa basar.
    if (okul && okul.id != null) ayarlar.okulId = okul.id;
    // Okul denemesi kaydı (2026-10-09, kullanıcı kararı): okul kapaklı PDF indir/yazdır deneme
    // kaydını yazar (kapaktaki karekod onu açar); önizleme ve ön kontrol yazmaz.
    if (okul && okul.id != null && formatTipi === 'pdf' && (cikti === 'indir' || cikti === 'yazdir')) {
      ayarlar.denemeKaydet = true;
    }
    if (abAcik) {
      ayarlar.abKitapcik = true;
      // Sistem soru numaraları A/B zip'indeki ayrı Excel'de; cevap anahtarı PDF'ine basılmaz (2026-10-13, kullanıcı).
      ayarlar.cevapAnahtariPublicNo = false;
    }
    if (!akilliDizgi) ayarlar.akilliSira = false;
    else if (/^\d+$/.test(String(sayfaHedefi).trim()) && Number(sayfaHedefi) >= 4) ayarlar.sayfaHedefi = Number(sayfaHedefi);
    const body = {};
    if (tamDeneme) {
      ayarlar.deneme = sinavTuru;
      ayarlar.denemeKapsam = 'tam';
      ayarlar.oncekiDenemeHaric = oncekiDenemeHaric;
      if (yayineviId != null && ayniYayineviDahil) ayarlar.ayniYayineviDahil = true;
      const dz = denemeZorlukKur(dersZorluk, konuZorluk, denemeFizibilite);
      if (dz) ayarlar.denemeZorluk = dz;
      if (!manifestiAtla && denemeManifest) ayarlar.denemeManifest = manifestYalinlastir(denemeManifest);
      body.filtre = { mufredat: mufredat || undefined, haric };
      // LGS oturum denemesi (2026-10-21): LGS kapak tasarımı tam denemede de (YKS tam denemesi ÖSYM kapağıdır).
      if (LGS_MODU && kapakTasarimlari(true).some(k => k.id === kapakTasarim)) ayarlar.kapakTasarim = kapakTasarim;
      if (denemeTarih.min) body.filtre.tarih_min = denemeTarih.min;
      if (denemeTarih.max) body.filtre.tarih_max = denemeTarih.max;
    } else {
      const sabitle = Array.isArray(sabitIds) && sabitIds.length > 0;
      const secili = Array.isArray(kaynakSorular) ? kaynakSorular : seciliSorular;
      // Tek dersli SABİT liste (numara listesi, 2026-10-09): kimliklerle basılır — filtre
      // kanalının tek ders dalı sabit listeyi taşımaz (dersPlani yalnız çok derslide kurulur).
      const tekSabit = kaynakModu === 'filtre' && !cokDersli && konuDersler[0]
        && Array.isArray(konuDersler[0].sabitIds) && konuDersler[0].sabitIds.length > 0;
      if (sabitle) body.soruIds = sabitIds;
      else if (kaynakModu === 'secili') body.soruIds = secili.map(s => s.id);
      else if (tekSabit) body.soruIds = konuDersler[0].sabitIds;
      else body.filtre = konuFiltresiOlustur(haric);
      // Başlık bandı için ders: filtre kanalında tek derste; seçili kanalda tüm
      // sorular tek dersteyse (karma listede ders sızıntısı kapısına takılmasın).
      const ders = kaynakModu === 'filtre' ? (cokDersli ? '' : konuTest.ders) : seciliTekDers(secili);
      if (ders) ayarlar.ders = ders;
      // ÇOK DERSLİ GENEL DENEME: sabitlenmiş soruIds kanalında da ÖSYM blok gruplaması
      // korunsun (ayarlar.genelDeneme); kapak seti + kurum/tarih tam denemedeki gibi.
      // ÖSYM kapak seti HER konu testinde (2026-09-04, kullanıcı kararı): çok derslide
      // genel deneme kimliği; tek derste / seçili listede "KONU TESTİ" kimliği (kapakSeti).
      // Kazanım adları alt satırı KALDIRILDI (2026-10-09, kullanıcı kararı: kapakta konu yazmaz).
      if (kaynakModu === 'filtre' && cokDersli) {
        ayarlar.genelDeneme = { sinav: konuTest.sinav };
      } else {
        ayarlar.kapakSeti = 'osym';
      }
      // Figma kapak tasarımı: ön + arka kapak HTML (sunucu texlive-api/kapak); sınıf rozeti İçerik'ten.
      if (kapakTasarimlari(LGS_MODU).some(k => k.id === kapakTasarim)) {
        ayarlar.kapakTasarim = kapakTasarim;
        if ([9, 10, 11, 12].includes(Number(konuTest.sinif))) ayarlar.kapakSinif = Number(konuTest.sinif);
      }
      // ÖĞRENME KANITI (9/10/11. sınıf işlenen konular denemesi): kapak türü; soru seçimi değişmez.
      // Öğrenme Kanıtı 9-11. sınıf ürünü; 12. sınıf içerikte kapak 9-11 yazardı → gönderilmez.
      if (kanit.acik && Number(konuTest.sinif) !== 12) {
        ayarlar.kapakTur = 'kanit';
        // Sınıf: İçerik'te sınıf süzgeci seçiliyse o (tek kaynak), değilse kapaktaki seçim.
        const kSinif = [9, 10, 11].includes(Number(konuTest.sinif)) ? Number(konuTest.sinif) : kanit.sinif;
        ayarlar.kanit = { sinif: kSinif };
        if (kSinif === 11 && ['SAY', 'EA'].includes(kanit.alan)) ayarlar.kanit.alan = kanit.alan;
        const u = Number(kanit.uygulama);
        if (Number.isInteger(u) && u >= 1 && u <= 20) ayarlar.kanit.uygulama = u;
        // Hafta süzgeci açıksa kapak alt satırı "1-N. HAFTA KONULARI".
        if (kaynakModu === 'filtre' && [9, 10, 11].includes(Number(konuTest.sinif)) && Number(konuTest.hafta) >= 1) {
          ayarlar.kanit.hafta = Number(konuTest.hafta);
        }
      }
    }
    body.ayarlar = ayarlar;
    return { body, tamDeneme };
  };

  // Basım kilidi — TEK kaynak.
  const basimKilidi = (() => {
    if (tamDenemeAktif) {
      if (denemeFizibilite && denemeFizibilite.uygun === false) {
        return (denemeFizibilite.konu_hatalari || []).length > 0 ? 'bilinmeyen konu adı' : 'havuz yetersiz';
      }
      const bos = bosSlotSayisi(denemeManifest);
      if (bos > 0) return `${bos} boş slot var`;
      if (!zorlukGecerliMi(dersZorluk, denemeFizibilite)) return 'zorluk dağılımı kotayla uyuşmuyor';
      return null;
    }
    if (sbAktif) return sbKilidi(sb, yayineviId);
    if (kaynakModu === 'filtre' && konuDersler.length === 0) return 'ders seçilmedi';
    if (kaynakModu === 'secili' && seciliCount === 0) return 'soru seçilmedi';
    return null;
  })();

  // ============================================================
  // TAM DENEME — liste / slot işlemleri
  // ============================================================
  const denemeOlustur = async () => {
    if (!tamDenemeAktif) return;
    setManifestYukleniyor(true);
    setManifestNot(null);
    setHata(null);
    const token = localStorage.getItem('yks_token');
    const { body } = ayarlarKur({ formatTipi: 'on-kontrol', manifestiAtla: true });
    try {
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/on-kontrol`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
        body: JSON.stringify({ ...body, tip: 'kitapcik' }),
      });
      const d = await r.json();
      if (yayineviEngeliMi(d) || grupEngeliMi(d)) { setManifestYukleniyor(false); return; }
      if (d.basarili && d.deneme_manifest) {
        setDenemeManifest(d.deneme_manifest);
        setOnizleme(null);
        const konuIstendi = !!(body.ayarlar.denemeZorluk
          && Object.values(body.ayarlar.denemeZorluk).some(x => x && x.konular));
        const tarihIstendi = !!(body.filtre && (body.filtre.tarih_min || body.filtre.tarih_max));
        if (konuIstendi && !(d.uygulanan && d.uygulanan.konuZorluk)) {
          setManifestNot('Sunucu konu bazlı seviyeyi UYGULAMADI (sunucu sürümü eski olabilir) — liste ders profiliyle kuruldu.');
        } else if (tarihIstendi && !(d.uygulanan && d.uygulanan.tarih)) {
          // Sessiz no-op korumasi: eski sunucu tarihi yok sayip TUM havuzdan secerdi.
          setManifestNot('Sunucu tarih aralığını UYGULAMADI (sunucu sürümü eski olabilir) — liste tüm havuzdan kuruldu.');
        } else {
          setManifestNot(null);
        }
      } else {
        setHata(basimHataMesaji(d, 'Deneme listesi oluşturulamadı'));
        setHataDetay(basimHataDetayi(d));
      }
    } catch (e) {
      setHata('Deneme listesi oluşturulamadı: ' + e.message);
    }
    setManifestYukleniyor(false);
  };

  const slotCikar = (ders, idx) => {
    setDenemeManifest(prev => {
      if (!prev) return prev;
      const kopya = JSON.parse(JSON.stringify(prev));
      for (const t of kopya.testler) {
        for (const d of t.dersler) {
          if (d.ders !== ders) continue;
          const hedef = d.sorular[idx];
          if (!hedef) return prev;
          const grup = hedef.baglam_grubu;
          d.sorular = d.sorular.map((x, i) => {
            if (i === idx || (grup && x && x.baglam_grubu === grup)) {
              if (x && x.konu) cikarilanKonuRef.current[`${ders}:${i}`] = x.konu;
              return null;
            }
            return x;
          });
        }
      }
      return kopya;
    });
    setAktifSlot({ ders, idx });
  };
  const slotAta = (ders, idx, soru) => {
    setDenemeManifest(prev => {
      if (!prev) return prev;
      const kopya = JSON.parse(JSON.stringify(prev));
      for (const t of kopya.testler) {
        for (const d of t.dersler) {
          if (d.ders === ders) d.sorular[idx] = soru;
        }
      }
      return kopya;
    });
    setAktifSlot(null);
  };
  const slotGovdesi = (ders, kova, haric, idx) => {
    // Konu bazlı seviye yedek öneride de geçerli (Faz A): kova haritası eski sözleşmeyle
    // (yalnız kovalı konular), adetli konular `konuSabit` ile YASAK (tam N; 2026-09-03 gece).
    // Çıkarılan sorunun konusu adetliyse `konu` gider → aynı konudan yedek (N korunur).
    const kovaHarita = konuKovaHaritasi(konuZorluk[ders]);
    const sabit = konuSabitListesi(konuZorluk[ders]);
    const cikarilan = idx != null ? cikarilanKonuRef.current[`${ders}:${idx}`] : undefined;
    return {
      ders, kova: kova || 'orta', haric,
      mufredat: mufredat || undefined,
      yayineviId: yayineviId != null ? yayineviId : undefined,
      ayniYayineviDahil: yayineviId != null && ayniYayineviDahil ? true : undefined,
      konuOverride: Object.keys(kovaHarita).length > 0 ? kovaHarita : undefined,
      konuSabit: sabit.length > 0 ? sabit : undefined,
      konu: cikarilan && sabit.includes(cikarilan) ? cikarilan : undefined,
      // Slot yenileme araligi KORUR: "son 7 gun" denemesinde bir soruyu
      // degistirince havuz disindan soru gelmesin (tek kaynak slotGovdesi).
      tarih_min: denemeTarih.min || undefined,
      tarih_max: denemeTarih.max || undefined,
    };
  };
  const slotOtoDoldur = async (ders, idx, kova) => {
    const token = localStorage.getItem('yks_token');
    try {
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/deneme-slot-doldur`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
        body: JSON.stringify(slotGovdesi(ders, kova, manifestPublicNolar(denemeManifest), idx)),
      });
      const d = await r.json();
      if (d.basarili) slotAta(ders, idx, d.soru);
      else setHata(d.hata || 'Yedek soru bulunamadı');
    } catch (e) {
      setHata('Yedek soru alınamadı: ' + e.message);
    }
  };
  const tumBosSlotlariDoldur = async () => {
    const bosSlotlar = [];
    (denemeManifest?.testler || []).forEach(t => t.dersler.forEach(d => {
      d.sorular.forEach((x, i) => { if (!x) bosSlotlar.push({ ders: d.ders, idx: i }); });
    }));
    if (bosSlotlar.length === 0) return;
    setManifestYukleniyor(true);
    let calisan = denemeManifest;
    const token = localStorage.getItem('yks_token');
    for (const slot of bosSlotlar) {
      try {
        const r = await fetch(`${apiUrl}/api/boru-hatti/basim/deneme-slot-doldur`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
          body: JSON.stringify(slotGovdesi(slot.ders, 'orta', manifestPublicNolar(calisan), slot.idx)),
        });
        const d = await r.json();
        if (!d.basarili) { setHata(d.hata || `${slot.ders} için yedek bulunamadı`); break; }
        const kopya = JSON.parse(JSON.stringify(calisan));
        for (const t of kopya.testler) {
          for (const dd of t.dersler) if (dd.ders === slot.ders) dd.sorular[slot.idx] = d.soru;
        }
        calisan = kopya;
      } catch (e) {
        setHata('Yedek soru alınamadı: ' + e.message);
        break;
      }
    }
    setDenemeManifest(calisan);
    setAktifSlot(null);
    setManifestYukleniyor(false);
  };
  // Yerel token sarmalayıcı — App.js `authFetch` geçirmezse (eski kullanım) YayineviSecici
  // için AuthContext.authFetch ile aynı imzayı (url, options) sağlar.
  const satisAuthFetch = useCallback((url, options = {}) => {
    const token = localStorage.getItem('yks_token');
    const headers = { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) };
    if (options.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
    return fetch(url, { ...options, headers });
  }, []);
  const yetkiliFetch = authFetch || satisAuthFetch;

  // A/B kitapçık türü / açık-kapalı değişince önizleme AYNI sabit listeyle yeniden derlenir
  // (ön kontrol yeniden koşarsa yeni seçim yapar → B'nin soruları A'dan farklı olurdu).
  const abTurDegistir = (acik, tur) => {
    setAbKitapcik(acik);
    setKitapcikTuru(tur);
    if (onizleme && Array.isArray(onizleme.soru_id_listesi) && onizleme.soru_id_listesi.length > 0) {
      onizlemeOlustur(undefined, undefined, { sabitIds: onizleme.soru_id_listesi, tur, ab: acik });
    }
  };

  // Yayınevi seçimi (Çıktı bölümü): kapak kurum adı boşsa ya da önceki yayınevi adıysa
  // yeni yayınevi adıyla ön-dolar; kullanıcı elle yazdıysa dokunulmaz.
  // "Soruları sistemden düşür" açılınca okul seçiliyse alıcı o okul (ortak kurum/kişi listesi,
  // 2026-10-09 kullanıcı kararı): yayınevi listesinde bul-veya-ekle (normalize ad). Alıcı elle
  // seçildiyse dokunulmaz.
  useEffect(() => {
    if (!yayineviTeslim || !okul || !okul.ad || yayinevi) return;
    let iptal = false;
    yetkiliFetch(`${apiUrl}/api/yayinevi`, { method: 'POST', body: JSON.stringify({ ad: okul.ad }) })
      .then(r => r.json())
      .then(d => { if (!iptal && d && d.basarili && d.yayinevi) yayineviSec({ id: Number(d.yayinevi.id), ad: d.yayinevi.ad }); })
      .catch(() => {});
    return () => { iptal = true; };
  }, [yayineviTeslim, okul && okul.id]);   // yalnız açılış / okul değişimi tetikler

  const yayineviSec = (y) => {
    setKurum(prev => ((!prev.trim() || prev === ((yayinevi && yayinevi.ad) || '')) ? ((y && y.ad) || prev) : prev));
    setYayinevi(y);
    setYayineviEngel(null);
    setGrupEngel(null);
  };

  // 409 satilmis_soru_baska_yayinevi: engel bandı; çağıran akışı durdurur.
  const yayineviEngeliMi = (d) => {
    if (!d || d.red_nedeni !== 'satilmis_soru_baska_yayinevi') return false;
    setYayineviEngel({ engel: Array.isArray(d.engel) ? d.engel : [], hata: d.hata || '' });
    return true;
  };
  // Seçili kanal: engelli soruları listeden çıkar (tam denemede manifest kanalı — yok).
  const engellileriCikar = () => {
    const nolar = new Set((yayineviEngel?.engel || []).map(e => Number(e.public_no)).filter(Number.isFinite));
    setSeciliSorular(prev => prev.filter(s => !nolar.has(Number(s.public_no))));
    setYayineviEngel(null);
    setGrupEngel(null);
    setOnizleme(null); setOnKontrol(null);
  };

  // 409 baglam_grubu_eksik (2026-09-15): bağlam grubu tamamlanamadı → grup bandı; akış durur.
  const grupEngeliMi = (d) => {
    if (!d || d.red_nedeni !== 'baglam_grubu_eksik') return false;
    setGrupEngel({ grup_eksik: Array.isArray(d.grup_eksik) ? d.grup_eksik : [], hata: d.hata || '' });
    return true;
  };
  // Sunucunun kitapçığa eklediği kardeşler: ön kontrol + önizleme (+ PDF) yanıtları
  // BİRLEŞİR — sabitlenmiş listeyle yapılan render aynı kardeşi yeniden bildirmez.
  const grupEklenenIsle = (d) => {
    const nolar = (d && Array.isArray(d.grup_eklenen) ? d.grup_eklenen : []).map(Number).filter(Number.isFinite);
    if (nolar.length > 0) setGrupEklenen(prev => [...new Set([...prev, ...nolar])]);
  };
  // Grubu tamamlanamayan sorular (bandın `public_no`'ları).
  const grupEngelliNolar = [...new Set(((grupEngel && grupEngel.grup_eksik) || [])
    .map(g => Number(g.public_no)).filter(Number.isFinite))];
  // Seçili kanal: listeden çıkar (engellileriCikar gibi; yeniden Önizle kullanıcıda).
  // Filtre kanalı: bu basım turunda havuz dışına al (`haricNolar`) ve önizlemeyi yeniden
  // kur (atlananlariCikar gibi). Tam denemede yok — manifest değiştirilir.
  const grupEngellileriCikar = () => {
    if (tamDenemeAktif || grupEngelliNolar.length === 0) return;
    const cikar = new Set(grupEngelliNolar);
    setGrupEngel(null);
    if (kaynakModu === 'secili') {
      setSeciliSorular(prev => prev.filter(s => !cikar.has(Number(s.public_no))));
      setOnizleme(null); setOnKontrol(null);
      return;
    }
    const yeniHaric = Array.from(new Set([...haricNolar, ...grupEngelliNolar]));
    setHaricNolar(yeniHaric);
    setOnizleme(null);
    onizlemeOlustur(undefined, yeniHaric);
  };

  // ============================================================
  // ÖNİZLEME / PDF — tek çıktı kaynağı sunucu PDF
  // ============================================================
  const atlananlariCikar = () => {
    if (!onizleme?.atlanan_sorular?.length) return;
    const atlananNumaralar = onizleme.atlanan_sorular.map(a => Number(a.public_no)).filter(Number.isFinite);
    const yeniHaric = Array.from(new Set([...haricNolar, ...atlananNumaralar]));
    setHaricNolar(yeniHaric);
    setOnizleme(null);
    if (!tamDenemeAktif && kaynakModu === 'secili') {
      const atlananSet = new Set(atlananNumaralar);
      const kalanlar = seciliSorular.filter(s => !atlananSet.has(Number(s.public_no)));
      setSeciliSorular(kalanlar);
      onizlemeOlustur(kalanlar);
    } else {
      onizlemeOlustur(undefined, yeniHaric);
    }
  };

  const onizlemeOlustur = async (overrideSorular, overrideHaric, secenek = {}) => {
    const kaynakSorular = Array.isArray(overrideSorular) ? overrideSorular : seciliSorular;
    setYukleniyor(true);
    setHata(null); setHataDetay(null); setLayoutIhlalIstek(null);
    setOnizleme(null);
    setCozumDurum(null);   // yeni önizleme = eski çözüm durumu artık bu kitapçığın değil
    setAnahtarPdf(null);
    setDizgiDurum(null);
    setOnKontrol(null);
    setYayineviEngel(null);
    setGrupEngel(null);
    setGrupEklenen([]);    // yeni önizleme = yeni kitapçık; kardeş şeridi bu yanıtlardan kurulur
    // secenek.sabitIds: A/B türü değişince AYNI liste yeniden derlenir (ön kontrol YOK — yeni
    // seçim yapılırsa B'nin soruları A'dan farklı olurdu).
    const { body, tamDeneme } = ayarlarKur({
      formatTipi: 'svg', overrideHaric, kaynakSorular,
      sabitIds: secenek.sabitIds || null, tur: secenek.tur || null, ab: secenek.ab == null ? null : secenek.ab,
    });
    if (tamDeneme && denemeManifest && bosSlotSayisi(denemeManifest) > 0) {
      setHata(`Denemede ${bosSlotSayisi(denemeManifest)} boş slot var — format kilitli. `
        + 'Boş slotları doldurun ("Boşları otomatik doldur") veya soru seçin.');
      setYukleniyor(false);
      return;
    }
    if (sbAktif && basimKilidi) {
      setHata(`Soru bankası basılamaz: ${basimKilidi}`);
      setYukleniyor(false);
      return;
    }
    if (!sbAktif && !tamDeneme && kaynakModu === 'secili' && kaynakSorular.length === 0) {
      setHata('En az 1 soru seçilmeli');
      setYukleniyor(false);
      return;
    }
    if (!sbAktif && !tamDeneme && kaynakModu === 'filtre' && konuDersler.length === 0) {
      setHata('Konu testi için en az bir ders seçilmeli.');
      setYukleniyor(false);
      return;
    }
    const token = localStorage.getItem('yks_token');
    const basliklar = { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };

    // ÖN KONTROL: render'dan önce aynı gövdeyle /basim/on-kontrol. Filtre
    // kanalında ön kontrolün SEÇTİĞİ sorular `soruIds` ile render'a sabitlenir
    // → şerit / önizleme / PDF aynı küme. Tam deneme hariç (manifest kanalı).
    if (!tamDeneme && !secenek.sabitIds && !sbAktif) {
      try {
        const ok = await fetch(`${apiUrl}/api/boru-hatti/basim/on-kontrol`, {
          method: 'POST', headers: basliklar,
          body: JSON.stringify({ ...body, tip: 'kitapcik', ayarlar: { ...body.ayarlar, formatTipi: 'on-kontrol' } }),
        });
        const rapor = await ok.json();
        // Başka yayınevine satılmış soru / tamamlanamayan bağlam grubu → bant, render denenmez.
        if (yayineviEngeliMi(rapor) || grupEngeliMi(rapor)) { setYukleniyor(false); return; }
        if (rapor && rapor.basarili && rapor.on_kontrol) {
          grupEklenenIsle(rapor);
          setOnKontrol(onKontrolOzetle(rapor, body));
          // Ders → kimlik haritası (secim_detay ile soru_id_listesi aynı sırada).
          if (Array.isArray(rapor.secim_detay) && Array.isArray(rapor.soru_id_listesi)
              && rapor.secim_detay.length === rapor.soru_id_listesi.length) {
            const harita = {};
            rapor.secim_detay.forEach((sd, i) => { (harita[sd.ders] = harita[sd.ders] || []).push(rapor.soru_id_listesi[i]); });
            setDersIdleri(harita);
          }
          if (body.filtre && Array.isArray(rapor.soru_id_listesi) && rapor.soru_id_listesi.length > 0) {
            delete body.filtre;
            body.soruIds = rapor.soru_id_listesi;
          }
        } else if (rapor && rapor.basarili === false && rapor.red_nedeni) {
          setHata(basimHataMesaji(rapor, 'Ön kontrol reddetti'));
          setHataDetay(basimHataDetayi(rapor));
          setYukleniyor(false);
          return;
        }
      } catch (_) { /* ön kontrol ulaşılamadı — render yine denenir */ }
    }

    try {
      setBasimSn(0);
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/${sbAktif ? 'soru-bankasi?is=1' : 'kitapcik'}`, {
        method: 'POST', headers: basliklar, body: JSON.stringify(body),
      });
      const data = await basimIsBekle(apiUrl, r, basliklar, { ilerleme: setBasimSn });
      if (yayineviEngeliMi(data) || grupEngeliMi(data)) { setYukleniyor(false); return; }
      if (data.basarili && (data.svg || data.svg_ana)) {
        grupEklenenIsle(data);
        setDizgiDurum(data.dizgi || null);
        if (data.basilan_sira && data.kitapcik_turu) setAbSira(prev => abSiraKaydet(prev, data.kitapcik_turu, data.basilan_sira));
        setOnizleme({
          svg_ana: data.svg_ana || data.svg,
          svg_cozum: data.svg_cozum || null,
          soru_id_listesi: data.soru_id_listesi || [],
          public_no_listesi: data.public_no_listesi || [],
          sayfa_sayisi: data.sayfa_sayisi || null,
          soru_sayisi: data.soru_sayisi,
          talep_edilen_sayi: data.talep_edilen_sayi,
          atlanan_sayisi: data.atlanan_sayisi || 0,
          atlanan_sorular: data.atlanan_sorular || [],
          cozum_basarili: data.cozum_basarili,
          cozum_hata: data.cozum_hata,
          ders_kapsami: data.ders_kapsami || null,
          deneme_dagilim_kaynak: data.deneme_dagilim_kaynak || null,
          deneme_hedef_adet: data.deneme_hedef_adet ?? null,
          dusuk_puan_elenen: data.dusuk_puan_elenen || 0,
          dusuk_puan_elenen_public_no: data.dusuk_puan_elenen_public_no || [],
          deneme_modu: data.deneme_modu || null,
          sinav_turu: data.sinav_turu || null,
          deneme_raporu: data.deneme_raporu || null,
          deneme_kaynagi: data.deneme_kaynagi || null,
          yok_sayilan_filtreler: data.yok_sayilan_filtreler || [],
          uygulanan: data.uygulanan || null,
        });
        if (data.deneme_manifest_final) setDenemeManifest(data.deneme_manifest_final);
        gecmiseKaydet({
          tarih: Date.now(), format: urunBilgi.ad, urun, kaynakModu,
          soru_sayisi: data.soru_sayisi,
          baslik: urun === 'konu' ? (cokDersli ? `Genel Deneme · ${konuDersler.length} ders` : `${urunBilgi.kisa} · ${dersEtiketi(konuTest.ders)}`) : urunBilgi.ad,
        });
      } else {
        setHata(basimHataMesaji(data, 'Önizleme oluşturulamadı'));
        setHataDetay(basimHataDetayi(data));
      }
    } catch (e) {
      setHata(e.message);
    }
    setYukleniyor(false);
  };

  // "Uzman Denetimi" — basım öncesi son kontrol: önizlenen setin TAMAMI kurala dayalı
  // kontrollerden geçer (backend: /basim/on-kontrol + ayarlar.uzmanDenetim:true). AI
  // uzmanları backend çağıramaz — kart setin listesiyle routine komutunu verir.
  const uzmanDenetimCalistir = async () => {
    if (!onizleme?.soru_id_listesi?.length) return;
    setUzmanDenetimYukleniyor(true);
    setUzmanDenetimRaporu(null);
    const token = localStorage.getItem('yks_token');
    const { body } = ayarlarKur({ sabitIds: onizleme.soru_id_listesi });
    try {
      const r = await fetch(`${apiUrl}/api/boru-hatti/basim/on-kontrol`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
        body: JSON.stringify({ ...body, tip: 'kitapcik', ayarlar: { ...body.ayarlar, uzmanDenetim: true } }),
      });
      const d = await r.json();
      if (d.basarili && d.uzman_denetim) setUzmanDenetimRaporu(d.uzman_denetim);
      else setUzmanDenetimRaporu({ not: basimHataMesaji(d, 'Uzman denetimi çalıştırılamadı') });
    } catch (e) {
      setUzmanDenetimRaporu({ not: 'Uzman denetimi çalıştırılamadı: ' + e.message });
    }
    setUzmanDenetimYukleniyor(false);
  };

  // Okul seçiliyse dosya adı "PiriReis_9A_Soru_13_10_26" (okul · sınıf + kitapçık türü · içerik · tarih);
  // okulsuz basımda null → eski ad.
  const okulAdi = (tip, { uzanti = 'pdf', tur = null } = {}) => {
    if (!okul || !okul.ad || urun !== 'konu') return null;
    const sinif = [9, 10, 11, 12].includes(Number(konuTest.sinif)) ? Number(konuTest.sinif) : (kanit.acik ? kanit.sinif : null);
    return okulDosyaAdi({ okulAd: okul.ad, sinif, tur: tur != null ? tur : (abKitapcik ? kitapcikTuru : ''), tip, uzanti });
  };

  // PDF'siz satış kaydı (2026-10-20, kullanıcı: "basım daha önce yapıldı, yalnız satıldı kaydet"):
  // listedeki numaralar önizleme/PDF olmadan, PDF indirmeyle aynı kurallarla yazılır.
  // Liste yalnız Seçili kanalda ya da her dersi sabit (numara listesi) filtre kanalında bellidir.
  const kayitNolari = (() => {
    if (tamDenemeAktif || sbAktif) return null;
    if (kaynakModu === 'secili') return seciliCount > 0 ? seciliSorular.map(s => Number(s.public_no)) : null;
    if (konuDersler.length === 0 || !konuDersler.every(d => Array.isArray(d.sabitNolar) && d.sabitNolar.length > 0)) return null;
    return konuDersler.flatMap(d => d.sabitNolar);
  })();
  const yalnizSatisKaydet = async () => {
    if (!kayitNolari || teslimKilidi || kayitYaziliyor) return;
    if (!window.confirm(`${kayitNolari.length} soru PDF üretilmeden “${yayinevi.ad}” adına satıldı olarak kaydedilecek ve havuzdan düşecek. Devam edilsin mi?`)) return;
    setKayitYaziliyor(true);
    setHata(null);
    try {
      const r = await yetkiliFetch(`${apiUrl}/api/satis/basim-kaydi`, {
        method: 'POST',
        body: JSON.stringify({ public_no: kayitNolari, yayinevi_id: yayineviId, birim_fiyat: birimFiyatSayi }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.basarili) {
        const ayrinti = [...(d.engel || []), ...(d.uygun_degil || []), ...(d.grup_eksik || [])].map(x => `#${x.public_no}`).join(', ');
        setHata(`${d.hata || 'Kayıt yazılamadı'}${ayrinti ? ` (${ayrinti})` : ''}`);
        return;
      }
      setYayineviSonuc({ ...d, yayineviAd: yayinevi.ad });
      setFizibiliteSayaci(n => n + 1);
    } catch (e) {
      setHata(`Kayıt yazılamadı: ${e.message}`);
    } finally {
      setKayitYaziliyor(false);
    }
  };

  const pdfIndir = async ({ sabitIds = null, cikti = 'indir', layoutZorla = false, baski = false } = {}) => {
    if (sbAktif && basimKilidi) { setHata(`Soru bankası basılamaz: ${basimKilidi}`); return; }
    if (!sbAktif && !tamDenemeAktif && kaynakModu === 'secili' && seciliCount === 0) { setHata('Soru seçilmedi'); return; }
    // Baskı PDF'i HER SEFERİNDE sorulur (kullanıcı kararı 2026-10-06); onaysız istek gitmez.
    if (baski && !window.confirm(BASKI_ONAY_METNI)) return;
    // Yayınevine teslim açıkken yayınevi seçilmeden / geçersiz fiyatla PDF ÜRETİLMEZ
    // (kayıt yazan tek istek budur; yazdırma etkilenmez).
    if (cikti === 'indir' && teslimKilidi) { setHata(`PDF kilitli: ${teslimKilidi} — Çıktı bölümünde “Soruları sistemden düşür” alanını tamamlayın.`); return; }
    setYukleniyor(true);
    setHata(null); setHataDetay(null); setLayoutIhlalIstek(null);
    setCozumDurum(null);
    setAnahtarPdf(null);
    setDizgiDurum(null);
    setBaskiDurum(null);
    setYayineviEngel(null);
    setGrupEngel(null);
    // A/B açıkken PDF tek tıklamayla İKİ türü üretir (2026-10-13, kullanıcı isteği): A derlenir, B
    // A'nın soru listesiyle derlenir; iki kitapçık + cevap anahtarları + A/B eşleme Excel'i TEK zip
    // (tarayıcı art arda ikinci otomatik indirmeyi engelliyor). Yazdır seçili türle tek kalır.
    const abToplu = abKitapcik && !tamDenemeAktif && !sbAktif && cikti === 'indir';
    const abSonuc = [];
    let abIds = sabitIds;
    for (const abTur of (abToplu ? ['A', 'B'] : [null])) {
      const { body, tamDeneme } = ayarlarKur({ formatTipi: 'pdf', sabitIds: abIds, cikti, layoutZorla, ...(abTur ? { tur: abTur, ab: true } : {}) });
      if (baski) body.ayarlar.baskiPdf = true;
      if (tamDeneme && denemeManifest && bosSlotSayisi(denemeManifest) > 0) {
        setHata(`Denemede ${bosSlotSayisi(denemeManifest)} boş slot var — format kilitli.`);
        setYukleniyor(false);
        return;
      }
      // Önizleme AYNI listeyi soru düşürmeden derlediyse PDF ön-derlemesi (test başına ayrı
      // derleme, 120 soruda ~17 sn) atlanır. Final derleme yine soru düşürürse sunucunun
      // tamamlama turu devrededir; liste değiştiyse ya da soru atlandıysa ön-derleme koşar.
      if (tamDeneme && denemeManifest && onizleme && !onizleme.atlanan_sayisi) {
        const kume = (a) => (a || []).map(Number).sort().join();
        const onizlenen = kume(onizleme.public_no_listesi);
        if (onizlenen && onizlenen === kume(manifestPublicNolar(denemeManifest))) body.ayarlar.denemeOnDerleme = false;
      }
      const token = localStorage.getItem('yks_token');
      try {
        const basliklar = { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };
        setBasimSn(0);
        const r = await fetch(`${apiUrl}/api/boru-hatti/basim/${sbAktif ? 'soru-bankasi?is=1' : 'kitapcik'}`, {
          method: 'POST', headers: basliklar, body: JSON.stringify(body),
        });
        const data = await basimIsBekle(apiUrl, r, basliklar, { ilerleme: setBasimSn });
        if (yayineviEngeliMi(data) || grupEngeliMi(data)) { setYukleniyor(false); return; }
        if (!data.basarili || !data.pdf_base64) {
          setHata(`${abTur ? `${abTur} kitapçığı: ` : ''}${basimHataMesaji(data, 'PDF üretilemedi')}`);
          setHataDetay(basimHataDetayi(data));
          // §16 reddi: "Yine de üret" düğmesi aynı isteği layoutZorla ile yineler.
          if (data.red_nedeni === 'layout_ihlal') setLayoutIhlalIstek({ sabitIds, cikti, baski });
          setYukleniyor(false);
          return;
        }
        const dosyaDers = urun === 'konu' ? (cokDersli && kaynakModu === 'filtre' ? 'genel-deneme' : (konuTest.ders || seciliTekDers(seciliSorular))) : '';
        if (abTur) {
          abSonuc.push({ tur: abTur, data, dosyaDers });
          abIds = data.soru_id_listesi;
          if (abTur === 'A') continue;
          abZipIndir(abSonuc, { baski });
        } else if (cikti === 'yazdir') {
          _pdfYazdir(data.pdf_base64);
        } else {
          _base64Indir(data.pdf_base64, baski
            ? (okulAdi('Soru_Baski') || dosyaAdiUret(urun, dosyaDers).replace(/\.pdf$/, '_baski.pdf'))
            : (okulAdi('Soru') || dosyaAdiUret(urun, dosyaDers)));
        }
        if (baski) setBaskiDurum(data.baski || { hata: 'Sunucu baskı dönüşümünü bildirmedi — inen dosya ekran PDF’i olabilir, matbaaya göndermeyin.' });
        // Çözümler aynı PDF'in sonunda (tek dosya — ikinci otomatik indirme YOK, tarayıcı
        // engelliyordu). Sunucu ekleyemediyse neden kutuda; inen PDF yalnız sorulardır.
        if (cozumDosyasiAyri && !sbAktif) {   // soru bankasında çözümler kitabın içinde
          const cs = data.cozum_sonda;
          setCozumDurum(cs && cs.basarili
            ? { bas: cs.sayfa_bas, son: cs.sayfa_son, noBas: cs.sayfa_no_bas, noSon: cs.sayfa_no_son }
            : { hata: (cs && cs.hata) || data.cozum_hata || 'Sunucu çözümleri PDF’e eklemedi' });
        }
        setDizgiDurum((abSonuc.length ? abSonuc[0].data.dizgi : data.dizgi) || null);
        for (const d of (abSonuc.length ? abSonuc.map(x => x.data) : [data])) {
          if (d.basilan_sira && d.kitapcik_turu) setAbSira(prev => abSiraKaydet(prev, d.kitapcik_turu, d.basilan_sira));
        }
        const anahtarHata = abSonuc.map(x => x.data.cevap_anahtari_hata).find(Boolean);
        if (abSonuc.length) setAnahtarPdf(anahtarHata ? { hata: anahtarHata } : null);   // anahtarlar zip'te
        else setAnahtarPdf(data.cevap_anahtari_pdf_base64
          ? { b64: data.cevap_anahtari_pdf_base64, ad: okulAdi('Cevap') || dosyaAdiUret(urun, dosyaDers).replace(/\.pdf$/, '_cevap_anahtari.pdf') }
          : (data.cevap_anahtari_hata ? { hata: data.cevap_anahtari_hata } : null));
        if (data.atlanan_sayisi > 0) {
          setOnizleme(prev => prev ? { ...prev, atlanan_sayisi: data.atlanan_sayisi, atlanan_sorular: data.atlanan_sorular } : prev);
        }
        if (data.deneme_manifest_final) setDenemeManifest(data.deneme_manifest_final);
        grupEklenenIsle(data);   // PDF aşamasında eklenen kardeş (önizleme teslim kapalıyken yapıldıysa)
        // Yayınevine teslim yazıldı: şerit (satış / fiyat bekliyor) + havuz fizibilitesi tazelenir.
        const isaret = abSonuc.length ? abSonuc[0].data.yayinevi_isaret : data.yayinevi_isaret;
        if (isaret) {
          setYayineviSonuc({ ...isaret, yayineviAd: (yayinevi && yayinevi.ad) || '' });
          setFizibiliteSayaci(n => n + 1);
        }
        setDenemeKayit(data.deneme_kayit || null);
        gecmiseKaydet({
          tarih: Date.now(), format: urunBilgi.ad, urun, kaynakModu,
          soru_sayisi: data.soru_sayisi,
          baslik: urun === 'konu' ? (dosyaDers === 'genel-deneme' ? `Genel Deneme · ${konuDersler.length} ders` : `${urunBilgi.kisa} · ${dersEtiketi(dosyaDers)}`) : urunBilgi.ad,
        });
      } catch (e) {
        setHata(`PDF indirme: ${e.message}`);
        return;
      } finally {
        // A'dan sonra B derlenecek: yükleniyor göstergesi arada sönmez.
        if (!(abTur === 'A' && abSonuc.length === 1)) setYukleniyor(false);
      }
    }
  };

  const _b64Bayt = (b64) => {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return u8;
  };

  // A + B kitapçık, A/B cevap anahtarları, öğrenme çıktısı Excel'i ve sistem numarası Excel'i tek zip.
  const abZipIndir = (abSonuc, { baski = false } = {}) => {
    const dosyalar = [];
    for (const { tur, data, dosyaDers } of abSonuc) {
      const eski = dosyaAdiUret(urun, dosyaDers).replace(/\.pdf$/, '');
      dosyalar.push({ ad: okulAdi(baski ? 'Soru_Baski' : 'Soru', { tur }) || `${eski}_${tur}${baski ? '_baski' : ''}.pdf`, veri: _b64Bayt(data.pdf_base64) });
      if (data.cevap_anahtari_pdf_base64) {
        dosyalar.push({ ad: okulAdi('Cevap', { tur }) || `${eski}_${tur}_cevap_anahtari.pdf`, veri: _b64Bayt(data.cevap_anahtari_pdf_base64) });
      }
    }
    const [a, b] = abSonuc.map(x => x.data.basilan_sira);
    if (a && b) {
      dosyalar.push({ ad: okulAdi('OgrenmeCiktisi', { uzanti: 'xlsx', tur: 'AB' }) || dosyaAdiUret(urun).replace(/\.pdf$/, '_AB_ogrenme_ciktisi.xlsx'), veri: abEslesmeXlsx(a, b) });
      dosyalar.push({ ad: okulAdi('SistemNo', { uzanti: 'xlsx', tur: 'AB' }) || dosyaAdiUret(urun).replace(/\.pdf$/, '_AB_sistem_no.xlsx'), veri: abSistemNoXlsx(a, b) });
    }
    const url = URL.createObjectURL(new Blob([zipUret(dosyalar)], { type: 'application/zip' }));
    const el = document.createElement('a');
    el.href = url;
    el.download = okulAdi('Kitapcik', { uzanti: 'zip', tur: 'AB' }) || dosyaAdiUret(urun, abSonuc[0].dosyaDers).replace(/\.pdf$/, '_AB.zip');
    document.body.appendChild(el); el.click(); el.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const yeniPenceredeAc = (svg, ek = '') => {
    if (!svg) return;
    const w = window.open('', '_blank');
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><title>YKS Basım${ek ? ' — ' + ek : ''}</title>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.11/dist/katex.min.css" />
<style>
body{margin:0;display:flex;justify-content:center;background:#eee;font-family:'Noto Serif',serif;}
.sayfa{max-width:21cm;width:100%;margin:24px;}
.sayfa .basim-sayfa{background:#fff;box-shadow:0 4px 12px rgba(0,0,0,0.15);}
.sayfa svg{display:block;margin:0 auto;width:100%;height:auto !important;}
@media print{body{background:#fff;display:block;}.sayfa{margin:0;max-width:none;width:210mm;}
.sayfa .basim-sayfa{max-width:none !important;margin:0 !important;box-shadow:none;width:210mm;height:297mm;overflow:hidden;break-after:page;page-break-after:always;}
.sayfa .basim-sayfa:last-child{break-after:auto;page-break-after:auto;}
.sayfa svg{width:210mm !important;height:297mm !important;margin:0 !important;}
@page{size:A4;margin:0;}}
</style></head><body><div class="sayfa">${tikzBoyutTemizle(svg)}</div></body></html>`);
    w.document.close();
  };

  // base64 → Blob → tarayıcı download
  const _base64Indir = (b64, dosyaAdi) => {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    const url = URL.createObjectURL(new Blob([u8], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = dosyaAdi;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 200);
  };

  // base64 PDF → gizli iframe → tarayıcının yazdırma önizlemesi (sunucu PDF'i).
  const _pdfYazdir = (b64) => {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    const url = URL.createObjectURL(new Blob([u8], { type: 'application/pdf' }));
    const eski = document.getElementById('basim-print-iframe');
    if (eski) eski.remove();
    const f = document.createElement('iframe');
    f.id = 'basim-print-iframe';
    f.setAttribute('aria-hidden', 'true');
    f.style.cssText = 'position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;';
    f.src = url;
    f.onload = () => {
      setTimeout(() => {
        try {
          f.contentWindow.focus();
          f.contentWindow.print();
        } catch (e) {
          window.open(url, '_blank');
        }
      }, 300);
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    };
    document.body.appendChild(f);
  };

  // ============================================================
  // UYARI / ÖZET
  // ============================================================
  const sayiUyarisi = useMemo(() => {
    if (sbAktif) return null; // soru bankası kendi kilidini (sbKilidi) taşır; konu testi uyarısı ona ait değil
    if (tamDenemeAktif) {
      if (denemeFizibilite && denemeFizibilite.uygun === false) {
        const eksik = denemeFizibilite.eksik_dersler || [];
        const eksikAd = eksik.map(e => (DERSLER.find(d => d.value === e.ders)?.label || e.ders)).join(', ');
        const mf = mufredat;
        const mufredatKaynakli = eksik.length > 0 && eksik.every(e => e.havuz === 0)
          && (mf === 'MEB_2018' || mf === 'Maarif_2024');
        const konuHata = (denemeFizibilite.konu_hatalari || []).join('; ');
        const cozum = mufredatKaynakli
          ? ` Bu dersler ${mf === 'MEB_2018' ? '2018' : 'Maarif'} müfredat havuzunda hiç yok — `
            + `müfredatı "Hepsi"${mf === 'MEB_2018' ? ' veya "Maarif"' : ' veya "2018"'} yapın.`
          : (eksik.length ? ' Onay bekleyen soruları onaylayarak havuzu genişletebilirsiniz.' : '');
        return {
          tip: 'hata',
          mesaj: `${urunBilgi.ad} basılamaz — ${eksikAd ? `eksik ders: ${eksikAd}.` : ''}${konuHata ? ` ${konuHata}.` : ''}${cozum}`,
        };
      }
      return null;
    }
    if (kaynakModu === 'secili') {
      if (seciliCount === 0) return { tip: 'hata', mesaj: 'Soru seçilmedi — "+ Soru Ekle" ile ekleyin ya da Filtre kaynağına geçin.' };
      if (seciliCount > SORU_ADET_MAX) return { tip: 'uyari', mesaj: `${seciliCount} soru — basım çok uzun olabilir (en çok ${SORU_ADET_MAX} önerilir).` };
      const dersSayisi = new Set(seciliSorular.map(s => String(s.ders || ''))).size;
      if (dersSayisi > 1) return { tip: 'bilgi', mesaj: `${dersSayisi} farklı dersten soru seçili — kitapçık başlığı ilk sorunun dersinden türer.` };
      return null;
    }
    if (konuDersler.length === 0) return { tip: 'hata', mesaj: 'En az bir ders seçin — birden fazla ders seçilirse ÖSYM çok-testli genel deneme basılır.' };
    const sifirDers = konuDersler.find(d => dersHedefAdet(d) < 1);
    if (sifirDers) return { tip: 'hata', mesaj: `${dersEtiketi(sifirDers.ders)} için soru sayısı en az 1 olmalı.` };
    if (konuHedefAdet > SORU_ADET_MAX) return { tip: 'uyari', mesaj: `Adet ${SORU_ADET_MAX}'den fazla — basım çok uzun olabilir.` };
    if (konuHedefAdet < 1) return { tip: 'hata', mesaj: 'Adet en az 1 olmalı.' };
    return null;
  }, [sbAktif, tamDenemeAktif, denemeFizibilite, mufredat, urunBilgi.ad, kaynakModu, seciliCount, seciliSorular,
      konuDersler, konuHedefAdet]);

  const pasifSebebi = basimKilidi ? `Basım kapalı: ${basimKilidi}` : (!onizleme ? 'Önce Önizle' : '');
  // Yalnız PDF (indirme) için ek kilit: yayınevine teslim eksik/geçersiz.
  const pdfPasifSebebi = pasifSebebi || (teslimKilidi ? `PDF kilitli: ${teslimKilidi}` : '');
  // Yapışkan çubuk özeti (kullanıcı kararı 2026-09-03): yalnız ürün + soru sayısı.
  // Diğer seçimler (müfredat, zorluk, liste, çıktı) kendi butonlarında belirgin görünür.
  const ozetAdet = tamDenemeAktif ? `${urunBilgi.toplam} soru`
    : kaynakModu === 'secili' ? `${seciliCount} seçili soru` : `${konuHedefAdet} soru`;
  const onizlemeyeKaydir = () => {
    const el = onizlemeRef.current;
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className="max-w-[1400px] mx-auto p-4 font-serif">
      {draftPromptGoster && (
        <div className="basim-yazdirilmaz mb-3 bg-blue-50 border border-blue-300 rounded-lg p-3 flex items-center justify-between">
          <div className="text-sm text-blue-800">
            <strong>Önceki taslak bulundu.</strong> Geri yüklemek ister misiniz?
          </div>
          <div className="flex gap-2">
            <button onClick={draftYukle} className="px-3 py-1 rounded bg-blue-600 text-white text-xs font-semibold">Geri Yükle</button>
            <button onClick={draftReddet} className="px-3 py-1 rounded border border-gray-400 text-xs">Yeni Başla</button>
          </div>
        </div>
      )}

      {/* HEADER */}
      <div className="flex items-center justify-between mb-3 basim-yazdirilmaz">
        <button onClick={onGeri} className="px-3 py-1.5 rounded-lg border border-gray-300 bg-white text-sm hover:bg-gray-50">← Geri</button>
        <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">🖨️ Basım ve Çıktı</h2>
        <button onClick={() => setGecmisAcik(!gecmisAcik)}
          className="px-3 py-1.5 rounded-lg border border-gray-300 bg-white text-sm hover:bg-gray-50">
          📚 Geçmiş & Şablonlar
        </button>
      </div>

      {/* Satış Arşivi → Basım (2026-09-14): numarayla seçilen onaylı sorular ön-seçili gelir;
          2026-09-15: yayınevi de ön-seçili (yeniden sorulmaz). */}
      {varsayilanCozumAyri && baslangicSeciliIds.length > 0 && (
        <div data-satis-basim-bilgi
          className="basim-yazdirilmaz mb-3 text-[12px] text-emerald-900 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-1.5">
          💰 Satış arşivinden {baslangicSeciliIds.length} soru — ÖSYM kitapçık düzeni;{' '}
          {cozumDosyasiAyri
            ? 'çözümler PDF’in sonunda gelir (Çıktı bölümünde “Çözümler PDF’in sonunda” açık).'
            : 'çözümler eklenmez (Çıktı bölümünde “Çözümler PDF’in sonunda” kapalı).'}
          {baslangicYayineviAd && (
            <> Yayınevi: <strong>{baslangicYayineviAd}</strong> — “Soruları sistemden düşür” açılırsa bu yayınevi seçili gelir;
              başka yayınevine satılmış soru bu kitapçığa giremez.</>
          )}
        </div>
      )}

      {gecmisAcik && (
        <GecmisVeSablonlarPaneli
          apiUrl={apiUrl} gecmis={gecmis} sablonlar={sablonlar}
          onSablonYukle={sablonYukle} onSablonSil={sablonSil} onSablonKaydet={sablonKaydet}
          onTaslakYukle={taslakYukle} aktifTaslakId={aktifTaslak ? aktifTaslak.id : null}
          onYenidenBas={yenidenBas}
          onKapat={() => setGecmisAcik(false)} />
      )}

      {/* === ÜRÜN SEÇİCİ === */}
      <div className="basim-yazdirilmaz mb-2 grid grid-cols-2 lg:grid-cols-4 gap-2" role="group" aria-label="Ürün">
        {(LGS_MODU ? LGS_URUN_SIRASI : URUN_SIRASI).map(id => {
          const u = URUNLER[id];
          const aktif = urun === id;
          return (
            <button key={id} type="button" data-urun={id} disabled={!!u.pasif} aria-pressed={aktif}
              onClick={() => urunSec(id)} title={urunAciklama(u)}
              className={`text-left p-3 rounded-xl border-2 transition-colors ${
                u.pasif ? 'border-dashed border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
                  : aktif ? 'border-blue-600 bg-blue-50 ring-2 ring-blue-300 shadow-sm' : 'border-gray-200 bg-white hover:bg-gray-50'}`}>
              <div className="flex items-center gap-2">
                <span className="text-xl">{u.ikon}</span>
                <div className="min-w-0">
                  <div className={`text-sm font-bold truncate ${aktif ? 'text-blue-700' : u.pasif ? 'text-gray-400' : 'text-gray-700'}`}>{aktif ? '✓ ' : ''}{u.ad}</div>
                  <div className="text-[10px] text-gray-500 leading-tight">
                    {u.pasif ? 'hazırlanıyor' : (u.toplam ? `${u.toplam} soru · ${u.formatAdi || 'ÖSYM formatı'}` : `ders(ler) · ${soz.ad} · adet · zorluk`)}
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {sablonNotu && (
        <div className="basim-yazdirilmaz mb-2 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5 flex items-center justify-between">
          <span>ℹ️ {sablonNotu}</span>
          <button onClick={() => setSablonNotu(null)} className="text-amber-600 hover:text-amber-900">✕</button>
        </div>
      )}

      {/* === YAPIŞKAN ÇUBUK: ürün · soru sayısı + Önizle / PDF / Yazdır (kullanıcı 2026-09-03:
          özet metinleri yok — seçimler kendi butonlarında görünür) === */}
      <div className="basim-yazdirilmaz sticky top-2 z-30 bg-white rounded-2xl shadow-lg border border-gray-200 mb-3 px-3 py-2">
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex items-center gap-2 text-sm flex-1 min-w-[220px]" data-ozet>
            <span className="font-bold text-gray-800">{urunBilgi.ikon} {urunBilgi.ad}</span>
            <span className="text-gray-300">·</span>
            <span className="font-semibold text-gray-700">{ozetAdet}</span>
          </div>
          {basimKilidi && (
            <span className="text-[11px] font-semibold text-red-700 bg-red-50 border border-red-200 rounded px-2 py-1"
              title="Bu neden giderilene kadar önizleme ve PDF kapalı">
              ⛔ Basım kapalı: {basimKilidi}
            </span>
          )}
          <div className="flex items-start gap-1.5">
            <div className="flex flex-col items-center">
              <button onClick={() => { onizlemeOlustur(); onizlemeyeKaydir(); }}
                disabled={yukleniyor || !!basimKilidi}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white font-bold text-sm hover:bg-blue-700 disabled:opacity-50 shadow-sm"
                title={basimKilidi ? `Basım kapalı: ${basimKilidi}` : 'Önizle (Ctrl+Enter) — sunucuda derlenir, kaç sayfa olduğu görünür'}>
                {yukleniyor ? `⏳ Hazırlanıyor${basimSn ? ` ${Math.floor(basimSn / 60)} dk ${basimSn % 60} sn` : ''}...` : '👁️ Önizle'}
              </button>
              {basimKilidi && <span className="text-[9px] text-red-600 leading-tight mt-0.5">kilitli</span>}
            </div>
            <div className="flex flex-col items-center">
              <button onClick={() => pdfIndir({ sabitIds: onizleme?.soru_id_listesi })}
                disabled={!onizleme || !!basimKilidi || yukleniyor || !!teslimKilidi}
                className="px-3 py-2 rounded-lg bg-green-600 text-white font-semibold text-sm hover:bg-green-700 disabled:opacity-40"
                title={pdfPasifSebebi || 'PDF İndir (Ctrl+S) — önizlenen kitapçığın aynısı'}>
                ⬇️ PDF
              </button>
              {pdfPasifSebebi && <span className={`text-[9px] leading-tight mt-0.5 ${teslimKilidi && !pasifSebebi ? 'text-red-600' : 'text-gray-500'}`}>{pdfPasifSebebi}</span>}
            </div>
            <div className="flex flex-col items-center">
              <button onClick={() => pdfIndir({ sabitIds: onizleme?.soru_id_listesi, baski: true })}
                disabled={!onizleme || !!basimKilidi || yukleniyor || !!teslimKilidi}
                className="px-3 py-2 rounded-lg bg-teal-700 text-white font-semibold text-sm hover:bg-teal-800 disabled:opacity-40"
                title={pdfPasifSebebi || 'Baskı PDF’i (matbaa) — CMYK, 3 mm taşma payı, PDF/X-4; her seferinde onay sorulur'}>
                🏭 Baskı PDF’i
              </button>
            </div>
            <div className="flex flex-col items-center">
              <button onClick={() => pdfIndir({ sabitIds: onizleme?.soru_id_listesi, cikti: 'yazdir' })}
                disabled={!onizleme || !!basimKilidi || yukleniyor}
                className="px-3 py-2 rounded-lg bg-gray-700 text-white font-semibold text-sm hover:bg-gray-800 disabled:opacity-40"
                title={pasifSebebi || "Yazdır (Ctrl+P) — önizlenen kitapçığın aynısı, sunucu PDF'i"}>
                🖨️ Yazdır
              </button>
              {pasifSebebi && <span className="text-[9px] text-gray-500 leading-tight mt-0.5">{pasifSebebi}</span>}
            </div>
            <div className="flex flex-col items-center">
              <button onClick={uzmanDenetimCalistir}
                disabled={!onizleme || uzmanDenetimYukleniyor}
                className="px-3 py-2 rounded-lg bg-purple-600 text-white font-semibold text-sm hover:bg-purple-700 disabled:opacity-40"
                title={`Uzman Denetimi — önizlenen setin basım öncesi son kontrolü (opsiyonel, PDF üretimini etkilemez)`}>
                {uzmanDenetimYukleniyor ? '⏳ Denetleniyor...' : '🎓 Uzman Denetimi'}
              </button>
              {!onizleme && <span className="text-[9px] text-gray-500 leading-tight mt-0.5">Önce Önizle</span>}
            </div>
          </div>
        </div>
      </div>

      {/* === UZMAN DENETİMİ — basım öncesi son kontrol raporu (opsiyonel, bloklamaz) === */}
      {uzmanDenetimRaporu && (
        <div data-uzman-denetimi className="basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs bg-purple-50 border border-purple-300 text-purple-900">
          <div className="flex items-start gap-2 mb-1.5">
            <span className="text-lg leading-none">🎓</span>
            <div className="flex-1">
              <div className="font-semibold">Uzman Denetimi — basım öncesi son kontrol</div>
              <div className="text-[10px] text-purple-700">Kurala dayalı kontroller; hepsi uyarıdır, basımı engellemez. Sayfa düzeni §16 ve Baskı PDF’i ön denetiminde.</div>
            </div>
            <button onClick={() => setUzmanDenetimRaporu(null)} className="text-purple-600 hover:text-purple-900" aria-label="Kapat">✕</button>
          </div>
          {uzmanDenetimRaporu.not && <div>{uzmanDenetimRaporu.not}</div>}
          {Array.isArray(uzmanDenetimRaporu.kontroller) && (
            uzmanDenetimRaporu.kontroller.length === 0
              ? <div>✅ İçerik kontrolleri: {uzmanDenetimRaporu.taranan} soruda bulgu yok.</div>
              : (
                <div className="mb-2" data-uzman-kontroller>
                  <div className="font-semibold mb-0.5">İçerik kontrolleri — {uzmanDenetimRaporu.kontroller.length} uyarı:</div>
                  {uzmanDenetimRaporu.kontroller.map((k, i) => (
                    <div key={`${k.public_no}-${k.kontrol}-${i}`}>
                      ⚠️ #{k.public_no} — {UZMAN_KONTROL_ADI[k.kontrol] || k.kontrol}: {k.mesaj}
                    </div>
                  ))}
                </div>
              )
          )}
          {Array.isArray(uzmanDenetimRaporu.soru_uzunlugu) && (
            uzmanDenetimRaporu.soru_uzunlugu.length === 0
              ? <div>✅ Soru uzunluğu sinyali: uzun çözüm / büyük figür kaynağı yok.</div>
              : (
                <div className="mb-2">
                  <div className="font-semibold mb-0.5">Soru uzunluğu sinyali:</div>
                  {uzmanDenetimRaporu.soru_uzunlugu.map(d => (
                    <div key={`${d.public_no}-${d.tur}`}>
                      #{d.public_no} — {d.tur === 'cozum_uzun' ? 'uzun çözüm' : 'büyük TikZ kaynağı'} ({d.uzunluk} &gt; {d.esik} karakter)
                    </div>
                  ))}
                </div>
              )
          )}
          {Array.isArray(uzmanDenetimRaporu.kazanim) && uzmanDenetimRaporu.kazanim.map(kz => (
            <div key={kz.ders} className="mt-1">
              <div className="font-semibold">{soz.Ad} yoğunluğu — {kz.ders} ({kz.n} soru)</div>
              {kz.not
                ? <div className="text-purple-700">{kz.not}</div>
                : kz.konular.filter(k => k.durum !== 'dengeli').length === 0
                  ? <div>✅ Konu dağılımı gerçek ÖSYM oranına yakın (±%{Math.round(kz.esik * 100)}, referans n={kz.gercek_referans_n}).</div>
                  : kz.konular.filter(k => k.durum !== 'dengeli').map(k => (
                    <div key={k.konu}>
                      {k.durum === 'fazla' ? '⬆️' : '⬇️'} {k.konu}: setteki {k.set_adet} soru · ÖSYM oranına göre beklenen ≈ {k.beklenen}
                    </div>
                  ))}
            </div>
          ))}
          {uzmanDenetimRaporu.harf && (() => {
            const h = uzmanDenetimRaporu.harf;
            const asan = h.bloklar.filter(b => b.asan && b.asan.length);
            const dizi = (h.dizi || []).filter(d => d.asti);
            return (
              <div className="mt-1" data-uzman-harf>
                <div className="font-semibold">Cevap harfi dağılımı (blokta her harf ≤ %{Math.round(h.oran * 100)})</div>
                {asan.length === 0
                  ? <div>✅ Tavanı aşan harf yok.</div>
                  : asan.map(b => (
                    <div key={`${b.tur}-${b.ad}`}>
                      ⚠️ {b.ad} ({b.n} soru): {b.asan.map(x => `${x} ${b.dagilim[x]}`).join(', ')} — tavan {b.tavan}
                    </div>
                  ))}
                {h.dizi
                  ? (dizi.length === 0
                    ? <div>✅ Art arda aynı harf en çok {h.dizi[0]?.tavan ?? 3}.</div>
                    : dizi.map(d => <div key={d.test}>⚠️ {d.test}: aynı harf {d.en_uzun} kez art arda (tavan {d.tavan})</div>))
                  : <div className="text-[10px] text-purple-700">Art arda aynı harf ölçülmedi: {h.dizi_olculmedi}.</div>}
              </div>
            );
          })()}
          {uzmanDenetimRaporu.uzman_izi && (() => {
            const iz = uzmanDenetimRaporu.uzman_izi;
            const liste = (pn) => pn.map(n => `#${n}`).join(', ');
            return (
              <div className="mt-2" data-uzman-izi>
                <div className="font-semibold">Son uzman incelemesi (routine)</div>
                {iz.uzmanlar.length === 0
                  ? <div className="text-purple-700">Bu set için uzman incelemesi yok — aşağıdaki komutla başlatın.</div>
                  : iz.uzmanlar.map(u => (
                    <div key={u.ad}>
                      {u.ad}: {u.incelenen} soru incelendi · {u.temiz} temiz
                      {u.bulgulu.length > 0 && <> · ⚠️ bulgulu {liste(u.bulgulu)}</>}
                      {u.olculmedi.length > 0 && <> · ölçülmedi {liste(u.olculmedi)}</>}
                      {u.bayat.length > 0 && <> · ⏳ inceleme bayat {liste(u.bayat)}</>}
                      {u.son_tarih && <span className="text-[10px] text-purple-700"> · {String(u.son_tarih).slice(0, 16)}{u.rapor_yolu ? ` · ${u.rapor_yolu}` : ''}</span>}
                    </div>
                  ))}
                {iz.uzmanlar.length > 0 && iz.incelenmemis.length > 0 && (
                  <div>Uzman incelemesi olmayan: {liste(iz.incelenmemis)}</div>
                )}
              </div>
            );
          })()}
          {uzmanDenetimRaporu.routine_komutu && (
            <div className="mt-2" data-uzman-routine>
              <div className="font-semibold">Uzmanlara inceletin (dil, görsel, dizgi, kazanım, alan, set — Claude Code oturumunda):</div>
              <div className="font-mono text-[10px] bg-white border border-purple-200 rounded px-1.5 py-1 break-all select-all">{uzmanDenetimRaporu.routine_komutu}</div>
            </div>
          )}
        </div>
      )}

      {/* === ÇÖZÜMLER PDF'İN SONUNDA — durum (tek dosya; ayrı indirme yok) === */}
      {cozumDurum && (
        <div data-cozum-pdf
          className={`basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs flex flex-wrap items-center gap-2 ${cozumDurum.hata
            ? 'bg-orange-50 border border-orange-300 text-orange-800'
            : 'bg-emerald-50 border border-emerald-300 text-emerald-900'}`}>
          <span className="flex-1 font-semibold">
            {cozumDurum.hata
              ? `⚠️ Çözümler eklenemedi: ${cozumDurum.hata} — inen PDF yalnız soruları içeriyor.`
              : `📘 Çözümler PDF’in sonunda${cozumDurum.bas && cozumDurum.son ? ` (PDF’in ${cozumDurum.bas}–${cozumDurum.son}. sayfaları)` : ''}${cozumDurum.noBas && cozumDurum.noSon ? ` — sayfa numarası kitapçıktan devam eder: ${cozumDurum.noBas}–${cozumDurum.noSon}` : ''}.`}
          </span>
          <button onClick={() => setCozumDurum(null)} className="text-gray-500 hover:text-gray-800" aria-label="Çözüm kutusunu kapat">✕</button>
        </div>
      )}

      {/* === CEVAP ANAHTARI — ayrı öğretmen PDF'i (okul sınavı) === */}
      {anahtarPdf && (
        <div data-anahtar-pdf
          className={`basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs flex flex-wrap items-center gap-2 ${anahtarPdf.hata
            ? 'bg-orange-50 border border-orange-300 text-orange-800'
            : 'bg-emerald-50 border border-emerald-300 text-emerald-900'}`}>
          <span className="flex-1 font-semibold">
            {anahtarPdf.hata
              ? `⚠️ Cevap anahtarı derlenemedi: ${anahtarPdf.hata}`
              : '🔑 Öğrenci kitapçığında cevap anahtarı yok; öğretmen için ayrı dosya hazır.'}
          </span>
          {!anahtarPdf.hata && (
            <button onClick={() => _base64Indir(anahtarPdf.b64, anahtarPdf.ad)} data-anahtar-indir
              className="px-2.5 py-1 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">
              Cevap anahtarını indir
            </button>
          )}
          <button onClick={() => setAnahtarPdf(null)} className="text-gray-500 hover:text-gray-800" aria-label="Cevap anahtarı kutusunu kapat">✕</button>
        </div>
      )}

      {/* === A/B EŞLEME LİSTESİ — Excel (A soru no · B soru no · öğrenme çıktısı) === */}
      {abKitapcik && abSira && (abSira.A || abSira.B) && (
        <div data-ab-eslesme className="basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs flex flex-wrap items-center gap-2 bg-violet-50 border border-violet-300 text-violet-900">
          <span className="flex-1 font-semibold">
            {abSira.A && abSira.B
              ? `📊 A/B eşleme listesi hazır (${abSira.A.length} soru): A soru no · B soru no · öğrenme çıktısı.`
              : `📊 A/B eşleme listesi: ${abSira.A ? 'A' : 'B'} kitapçığı hazır — ${abSira.A ? 'B' : 'A'} türünü seçip önizleyin ya da PDF alın.`}
          </span>
          {abSira.A && abSira.B && (
            <button data-ab-eslesme-indir
              onClick={() => {
                const bayt = abEslesmeXlsx(abSira.A, abSira.B);
                const url = URL.createObjectURL(new Blob([bayt], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const a = document.createElement('a');
                a.href = url; a.download = okulAdi('OgrenmeCiktisi', { uzanti: 'xlsx', tur: 'AB' }) || dosyaAdiUret(urun).replace(/\.pdf$/, '_AB_ogrenme_ciktisi.xlsx');
                document.body.appendChild(a); a.click(); a.remove();
                setTimeout(() => URL.revokeObjectURL(url), 1000);
              }}
              className="px-2.5 py-1 rounded bg-violet-600 text-white font-semibold hover:bg-violet-700">
              Excel'i indir
            </button>
          )}
        </div>
      )}

      {/* === AKILLI DİZGİ — sayfa sonucu (sunucu `dizgi` raporu) === */}
      {dizgiDurum && dizgiDurum.once && (
        <div data-dizgi-durum className="basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs flex flex-wrap items-center gap-2 bg-sky-50 border border-sky-300 text-sky-900">
          <span className="flex-1">
            {dizgiDurum.uygulandi && dizgiDurum.sonra
              ? `🧩 Akıllı dizgi: ${sbAktif ? 'sayfa' : 'soru sayfası'} ${dizgiDurum.once.sayfa} → ${dizgiDurum.sonra.sayfa}${dizgiDurum.once.bos ? ` (boş sütun ${dizgiDurum.once.bos} → ${dizgiDurum.sonra.bos})` : ''}. Sorular sütunları dolduracak biçimde yeniden dizildi; ${sbAktif ? 'test sınırları, kolaydan zora basamak sırası ve bağlam çifti korundu; soru haritası, karne, cevap anahtarı ve çözümler yeni sıraya göre.' : 'ders sırası ve bağlam grupları korundu, cevap anahtarı yeni sıraya göre.'}`
              : `🧩 Akıllı dizgi: ${dizgiDurum.once.sayfa} ${sbAktif ? 'sayfa' : 'soru sayfası'} — daha az sayfaya dizilemedi, sıra değişmedi.`}
            {dizgiDurum.hedef && dizgiDurum.hedef.sayfa
              ? ` · Sayfa hedefi ${dizgiDurum.hedef.hedef}: toplam ${dizgiDurum.hedef.sayfa} sayfa ${dizgiDurum.hedef.ulasildi ? '✓' : '— hedefe inilemedi'}${dizgiDurum.hedef.soru_arasi_olcek < 1 ? ` (soru arası boşluk %${Math.round(dizgiDurum.hedef.soru_arasi_olcek * 100)})` : ''}.`
              : ''}
          </span>
          <button onClick={() => setDizgiDurum(null)} className="text-gray-500 hover:text-gray-800" aria-label="Akıllı dizgi kutusunu kapat">✕</button>
        </div>
      )}

      {/* === BASKI PDF'İ — ön denetim sonucu === */}
      {baskiDurum && (
        <div data-baski-pdf
          className={`basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs ${baskiDurum.engelleyici || baskiDurum.hata
            ? 'bg-orange-50 border border-orange-300 text-orange-800'
            : 'bg-emerald-50 border border-emerald-300 text-emerald-900'}`}>
          <div className="flex items-center gap-2">
            <span className="flex-1 font-semibold">
              {baskiDurum.hata ? `⚠️ ${baskiDurum.hata}` : baskiDurum.engelleyici
                ? `⚠️ Baskı PDF’i indi ama ön denetimde ${baskiDurum.engelleyici} ENGELLEYİCİ bulgu var — matbaaya göndermeden düzeltin:`
                : `🏭 Baskı PDF’i indi: ${baskiDurum.profil ? `${baskiDurum.profil.standart} · ${baskiDurum.profil.renk} · ${baskiDurum.profil.tasma_mm} mm taşma payı` : 'PDF/X-4'} · ön denetim temiz.`}
            </span>
            <button onClick={() => setBaskiDurum(null)} className="text-gray-500 hover:text-gray-800" aria-label="Baskı kutusunu kapat">✕</button>
          </div>
          {baskiDurum.engelleyici > 0 && (
            <ul className="mt-1 ml-4 list-disc">
              {(baskiDurum.bulgular || []).filter(b => b.onem === 'ENGELLEYİCİ').slice(0, 8).map((b, i) => (
                <li key={i}>{b.sayfa ? `s. ${b.sayfa}: ` : ''}{b.ileti}</li>
              ))}
            </ul>
          )}
        </div>
      )}

      {/* === GENEL UYARILAR === */}
      {sayiUyarisi && (
        <div className={`basim-yazdirilmaz mb-3 rounded-lg p-2.5 text-xs flex items-center gap-2 ${
          sayiUyarisi.tip === 'hata' ? 'bg-red-50 border border-red-300 text-red-700'
          : sayiUyarisi.tip === 'uyari' ? 'bg-amber-50 border border-amber-300 text-amber-800'
          : 'bg-blue-50 border border-blue-200 text-blue-800'}`}>
          {sayiUyarisi.tip === 'hata' ? '⛔' : sayiUyarisi.tip === 'uyari' ? '⚠️' : 'ℹ️'} {sayiUyarisi.mesaj}
        </div>
      )}
      {haricNolar.length > 0 && (
        <div className="bg-slate-50 border border-slate-300 rounded-lg p-2 mb-3 text-[11px] text-slate-700 basim-yazdirilmaz flex items-center justify-between gap-2">
          <div>
            <strong>{haricNolar.length} soru</strong> derlenemediği ya da bağlam grubu tamamlanamadığı için bu basım turunda havuz dışında:{' '}
            <span className="font-mono text-slate-500">
              #{haricNolar.slice(0, 12).join(', #')}{haricNolar.length > 12 ? ' …' : ''}
            </span>
          </div>
          <button onClick={() => setHaricNolar([])}
            className="px-2 py-0.5 rounded bg-slate-600 text-white text-[10px] font-semibold hover:bg-slate-700 whitespace-nowrap">
            ↺ Geri al
          </button>
        </div>
      )}
      {/* BAŞKA YAYINEVİNE SATILMIŞ SORU ENGELİ (2026-09-15): sunucu 409 — kitapçık üretilmedi. */}
      {yayineviEngel && (
        <div data-yayinevi-engel
          className="bg-red-50 border-l-4 border-red-500 rounded-lg p-3 mb-3 text-sm text-red-800 basim-yazdirilmaz flex items-start gap-2">
          <span className="text-lg leading-none">⛔</span>
          <div className="flex-1">
            <div className="font-semibold">
              Başka yayınevine satılmış sorular kitapçığa giremez:{' '}
              {(yayineviEngel.engel || []).map(e => `#${e.public_no}${e.yayinevi ? ` (${e.yayinevi})` : ''}`).join(', ') || '—'}.
              {' '}Çıktı bölümünde doğru yayınevini seçin ya da bu soruları listeden çıkarın.
            </div>
            {yayineviEngel.hata && <div className="text-[11px] mt-0.5 opacity-80">{yayineviEngel.hata}</div>}
            {!tamDenemeAktif && kaynakModu === 'secili' && (yayineviEngel.engel || []).length > 0 && (
              <button type="button" onClick={engellileriCikar}
                title="Engelli soruları seçili listeden çıkarır; sonra yeniden Önizle"
                className="mt-1.5 px-2.5 py-1 rounded bg-red-600 text-white text-xs font-semibold hover:bg-red-700">
                Engelli {(yayineviEngel.engel || []).length} soruyu listeden çıkar
              </button>
            )}
          </div>
          <button onClick={() => setYayineviEngel(null)} className="text-red-500 hover:text-red-700 text-lg leading-none" aria-label="Engel bandını kapat">×</button>
        </div>
      )}
      {/* BAĞLAM GRUBU TAMAMLANAMADI (2026-09-15): sunucu 409 `baglam_grubu_eksik` — kitapçık üretilmedi. */}
      {grupEngel && (
        <div data-grup-engel
          className="bg-red-50 border-l-4 border-red-500 rounded-lg p-3 mb-3 text-sm text-red-800 basim-yazdirilmaz flex items-start gap-2">
          <div className="flex-1">
            <div className="font-semibold">🔗 Bağlam grubu tamamlanamadı — bağlam temelli sorular ayrı satılamaz:</div>
            <ul className="mt-1 ml-4 list-disc space-y-0.5 text-[12px]">
              {(grupEngel.grup_eksik || []).map((g, i) => (
                <li key={`${g.public_no}-${i}`} data-grup-engel-satir={g.public_no}>
                  #{g.public_no} — {grupEngelNedeni(g, tamDenemeAktif)}
                </li>
              ))}
            </ul>
            {grupEngel.hata && <div className="text-[11px] mt-1 opacity-80">{grupEngel.hata}</div>}
            {tamDenemeAktif ? (
              <div className="text-[11px] mt-1 font-semibold">
                Tam denemede soru sayısı sabit — bu soruyu deneme listesinde (slotu boşaltıp) başka bir soruyla
                değiştirin ya da Çıktı bölümünde “Soruları sistemden düşür” seçeneğini kapatın.
              </div>
            ) : grupEngelliNolar.length > 0 && (
              <button type="button" onClick={grupEngellileriCikar}
                title={kaynakModu === 'secili'
                  ? 'Bu soruları seçili listeden çıkarır; sonra yeniden Önizle'
                  : 'Bu soruları bu basım turunda havuz dışına alır ve önizlemeyi yeniden kurar'}
                className="mt-1.5 px-2.5 py-1 rounded bg-red-600 text-white text-xs font-semibold hover:bg-red-700">
                Bu {grupEngelliNolar.length} soruyu kitapçıktan çıkar
              </button>
            )}
          </div>
          <button onClick={() => setGrupEngel(null)} className="text-red-500 hover:text-red-700 leading-none" aria-label="Bağlam grubu bandını kapat">✕</button>
        </div>
      )}
      {/* BAĞLAM GRUBU TAMAMLANDI (2026-09-15): sunucu eksik kardeşleri kitapçığa ekledi. */}
      {grupEklenen.length > 0 && (
        <div data-grup-eklenen
          className="basim-yazdirilmaz mb-3 rounded-lg border border-indigo-200 bg-sky-50 p-2.5 text-[12px] text-indigo-900 flex items-start justify-between gap-2">
          <span>
            🔗 Bağlam grubu tamamlandı: <strong>{grupEklenen.map(n => `#${n}`).join(', ')}</strong> kitapçığa eklendi —
            bağlam temelli sorular yayınevine ayrı verilmez.
          </span>
          <button type="button" onClick={() => setGrupEklenen([])} className="text-indigo-500 hover:text-indigo-800 leading-none"
            aria-label="Bağlam grubu şeridini kapat">✕</button>
        </div>
      )}
      {hata && (
        <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-3 mb-3 text-sm text-red-700 basim-yazdirilmaz flex items-start gap-2">
          <span className="text-lg leading-none">⚠️</span>
          <div className="flex-1">
            <div className="font-semibold">{dostHataMesaji(hata)}</div>
            {layoutIhlalIstek && (
              <button type="button" onClick={() => pdfIndir({ ...layoutIhlalIstek, layoutZorla: true })}
                title="KURALLAR §16 kitapçık düzeni kapısını yalnız bu basım için atlar; PDF yine üretilir, ihlal uyarı olarak kalır"
                className="mt-1.5 px-2.5 py-1 rounded bg-red-600 text-white text-xs font-semibold hover:bg-red-700">
                Yine de üret — §16 kapısını atla
              </button>
            )}
            {(String(hata) !== dostHataMesaji(hata) || hataDetay) && (
              <details className="mt-1" open={!!hataDetay}>
                <summary className="text-[11px] cursor-pointer text-red-500">Teknik detay</summary>
                {hataDetay && (
                  <code className="text-[10px] text-red-500 block mt-1 whitespace-pre-wrap font-mono">{hataDetay}</code>
                )}
                {String(hata) !== dostHataMesaji(hata) && (
                  <code className="text-[10px] text-red-400 block mt-1">{String(hata)}</code>
                )}
              </details>
            )}
          </div>
          <button onClick={() => { setHata(null); setHataDetay(null); setLayoutIhlalIstek(null); }}
            className="text-red-500 hover:text-red-700 text-lg leading-none">×</button>
        </div>
      )}

      {/* === SEÇİMLER — içerik + çıktı, hepsi görünür (akordeon yok) === */}
      <div className="basim-yazdirilmaz rounded-2xl border border-gray-200 bg-white shadow-sm mb-3 px-4 py-3" data-secimler>
        <div className="text-[10px] font-bold uppercase text-gray-500">İçerik</div>
        {/* Deneme ürünlerinde açıklama bandını DenemePaneli (test kotalarıyla) basar. */}
        {!tamDenemeAktif && (
          <div className="mt-1 text-xs text-blue-900 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
            <strong>{urunBilgi.ad}</strong> — {urunAciklama(urunBilgi)}
          </div>
        )}
        {tamDenemeAktif ? (
          <DenemePaneli
            urun={urun} apiUrl={apiUrl} mufredat={mufredat} setMufredat={setMufredat}
            denemeFizibilite={denemeFizibilite}
            oncekiDenemeHaric={oncekiDenemeHaric} setOncekiDenemeHaric={setOncekiDenemeHaric}
            denemeTarih={denemeTarih} setDenemeTarih={setDenemeTarih}
            ayniYayineviDahil={ayniYayineviDahil} setAyniYayineviDahil={setAyniYayineviDahil}
            yayineviAd={(yayinevi && yayinevi.ad) || (yayineviId != null ? `#${yayineviId}` : '')}
            denemeOlustur={denemeOlustur} manifestYukleniyor={manifestYukleniyor}
            denemeManifest={denemeManifest} manifestNot={manifestNot} aktifSlot={aktifSlot}
            dersZorluk={dersZorluk} setDersZorluk={setDersZorluk}
            konuZorluk={konuZorluk} setKonuZorluk={setKonuZorluk}
            slotCikar={slotCikar} slotOtoDoldur={slotOtoDoldur} slotAta={slotAta}
            setAktifSlot={setAktifSlot} tumBosSlotlariDoldur={tumBosSlotlariDoldur} />
        ) : sbAktif ? (
          <SoruBankasiPaneli apiUrl={apiUrl} sb={sb} setSb={setSb} yayineviId={yayineviId} />
        ) : (
          <KonuTestiPaneli
            apiUrl={apiUrl} kaynakModu={kaynakModu} setKaynakModu={setKaynakModu}
            konuTest={konuTest} setKonuTest={setKonuTest} mufredat={mufredat} setMufredat={setMufredat}
            dersOzeti={dersOzeti} maarifOzeti={maarifOzeti} dersIdleri={dersIdleri} yayineviId={yayineviId} onYayineviSec={yayineviSec}
            numaraDolgu={numaraDolgu}
            aktifTaslak={aktifTaslak} taslakNot={taslakNot} onTaslakKaydet={taslakKaydet} onTaslakAc={() => setGecmisAcik(true)}
            seciliSorular={seciliSorular} seciliYukleniyor={seciliYukleniyor}
            eklePaneliAcik={eklePaneliAcik} setEklePaneliAcik={setEklePaneliAcik}
            soruyuSil={soruyuSil} soruyuTasi={soruyuTasi} dragHandlers={dragHandlers}
            seciliKaristir={seciliKaristir} seciliTemizle={seciliTemizle}
            soruEkle={soruEkle} sorulariEkle={sorulariEkle} />
        )}
        <div className="mt-4 pt-3 border-t border-gray-100">
          <div className="text-[10px] font-bold uppercase text-gray-500">Çıktı</div>
        <CiktiPaneli
          tamDenemeAktif={tamDenemeAktif} soruBankasi={sbAktif} genelDeneme={!tamDenemeAktif && kaynakModu === 'filtre' && cokDersli}
          cevapAnahtariGoster={cevapAnahtariGoster} setCevapAnahtariGoster={setCevapAnahtariGoster}
          cozumDosyasiAyri={cozumDosyasiAyri} setCozumDosyasiAyri={setCozumDosyasiAyri}
          yayineviTeslim={yayineviTeslim} setYayineviTeslim={setYayineviTeslim}
          apiUrl={apiUrl} authFetch={yetkiliFetch}
          yayinevi={yayinevi} onYayineviSec={yayineviSec}
          birimFiyat={birimFiyat} setBirimFiyat={setBirimFiyat} teslimKilidi={teslimKilidi}
          kayitAdet={kayitNolari ? kayitNolari.length : 0} onYalnizKaydet={yalnizSatisKaydet} kayitYaziliyor={kayitYaziliyor}
          yayineviSonuc={yayineviSonuc} setYayineviSonuc={setYayineviSonuc}
          denemeKayit={denemeKayit}
          onSatisArsivineGit={onSatisArsivineGit}
          kurum={kurum} setKurum={setKurum} sinavTarihi={sinavTarihi} setSinavTarihi={setSinavTarihi}
          sinavSuresi={sinavSuresi} setSinavSuresi={setSinavSuresi}
          sinavAdi={sinavAdi} setSinavAdi={setSinavAdi}
          kapakTasarim={kapakTasarim} setKapakTasarim={setKapakTasarim}
          okul={okul} setOkul={setOkul} kanit={kanit} setKanit={setKanit}
          icerikSinif={[9, 10, 11].includes(Number(konuTest.sinif)) ? Number(konuTest.sinif) : null}
          kanitKapali={Number(konuTest.sinif) === 12}
          abKitapcik={abKitapcik} kitapcikTuru={kitapcikTuru}
          akilliDizgi={akilliDizgi} onAkilliDizgi={() => setAkilliDizgi(!akilliDizgi)}
          sayfaHedefi={sayfaHedefi} setSayfaHedefi={setSayfaHedefi}
          onAbDegis={(acik) => abTurDegistir(acik, acik ? kitapcikTuru : 'A')}
          onTurDegis={(t) => abTurDegistir(true, t)} />
        </div>
      </div>

      {/* === ÖNİZLEME — Önizle'ye basınca buraya kaydırılır; seçimler yukarıda açık kalır === */}
      <div ref={onizlemeRef} className="basim-yazdirilmaz scroll-mt-24" data-onizleme-alani>
        <div className="flex items-center justify-between mb-2 px-1">
          <div className="text-[10px] font-bold uppercase text-gray-500">Önizleme</div>
          {onizleme && (
            <div className="text-[10px] text-gray-400">Ctrl+S PDF · Ctrl+P Yazdır · Esc Geri</div>
          )}
        </div>
      {onKontrol && (
        <div className="basim-yazdirilmaz mb-3 rounded-lg border border-sky-200 bg-sky-50 p-2.5 text-[11px] text-sky-900">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <div className="font-bold">
              🔎 Ön kontrol: {onKontrol.soru_sayisi} soru
              {onKontrol.istenen_adet != null ? ` / istenen ${onKontrol.istenen_adet}` : ''}
              {onKontrol.sabitlendi ? ' — önizleme ve PDF bu listeye sabitlendi' : ''}
            </div>
            <button onClick={() => setOnKontrol(null)} className="text-sky-500 hover:text-sky-800" title="Şeridi kapat">✕</button>
          </div>
          {onKontrol.satirlar.length > 0 ? (
            <ul className="mt-1 space-y-0.5">
              {onKontrol.satirlar.map((sat, i) => (
                <li key={i} className={sat.tip === 'uyari' ? 'text-amber-800 font-semibold' : ''}>
                  {sat.tip === 'uyari' ? '⚠️' : 'ℹ️'} {sat.metin}
                </li>
              ))}
            </ul>
          ) : <div className="mt-1 opacity-80">Uyarı yok — havuz istenen adedi karşılıyor.</div>}
        </div>
      )}

        {onizleme ? (
          <OnizlemePaneli
            onizleme={onizleme}
            gorselBoyut="orta"
            cozumDosyasiAyri={cozumDosyasiAyri}
            zoomYuzde={zoomYuzde}
            onZoomDegis={setZoomYuzde}
            onAtlananlariCikar={atlananlariCikar}
            onYeniPencere={yeniPenceredeAc}
            onSablonKaydet={sablonKaydet}
            onPdf={() => pdfIndir({ sabitIds: onizleme?.soru_id_listesi })}
            onYazdir={() => pdfIndir({ sabitIds: onizleme?.soru_id_listesi, cikti: 'yazdir' })}
            ciktiPasif={basimKilidi ? `Basım kapalı: ${basimKilidi}` : (yukleniyor ? 'Hazırlanıyor…' : '')}
            pdfPasif={teslimKilidi ? `PDF kilitli: ${teslimKilidi}` : ''}
          />
        ) : (
          <div className="bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200 p-6 text-center text-gray-400 flex flex-col items-center justify-center min-h-[150px]">
            {yukleniyor ? (
              <>
                <div className="text-3xl mb-2">⏳</div>
                <div className="font-bold text-gray-500">Önizleme hazırlanıyor…</div>
                <div className="text-xs mt-1">Sunucuda derleniyor; sayfa kutuları burada açılacak.</div>
              </>
            ) : (
              <>
                <div className="text-3xl mb-2">📄</div>
                <div className="font-bold text-gray-500">Önizleme</div>
                <div className="text-xs mt-1 max-w-sm">Yukarıdaki seçimleri yapıp <strong>👁️ Önizle</strong>'ye basın; sayfalar burada açılır, PDF ve Yazdır ondan sonra etkinleşir.</div>
                <div className="text-[10px] mt-2 text-gray-400">
                  <kbd className="bg-gray-200 px-1 rounded">Ctrl+Enter</kbd> Önizle ·{' '}
                  <kbd className="bg-gray-200 px-1 rounded">Ctrl+S</kbd> PDF ·{' '}
                  <kbd className="bg-gray-200 px-1 rounded">Ctrl+P</kbd> Yazdır
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* PRINT-ONLY view — yalnız tarayıcı MENÜSÜNDEN "Yazdır" seçilirse (yedek yol). */}
      {onizleme && yazdirKopyasi && (
        <div id="basim-print-kopya" className="hidden print:block">
          <div className="osym-onizleme" dangerouslySetInnerHTML={{ __html: tikzBoyutTemizle(onizleme.svg_ana) }} />
        </div>
      )}
    </div>
  );
}
